import type { I18nTranslations } from './i18n-en';

const i18n_bg: I18nTranslations = {
  close_btn: 'Затвори',
  search_placeholder: 'Търси',
  loading: 'Зарежда се',

  label_inactive: 'Неактивен',
  label_invalid: 'Невалиден',

  active_devices: 'Активни {{devices_len}} устройства',
  change_language: 'Смени езика',
  language_changed_message: 'Езикът е променен',

  error_select_device_message: 'Моля, първо изберете устройство',
  select_device: 'Изберете устройство',
  select_company_menu_message: 'Изберете компания, за да видите списъка с устройства',
  select_company_required_header: 'Изберете компания за да продължите',
  select_company_required_from: 'От тук: ',
  select_company_required_accounts_page_link: 'Акаунти',

  second: 'секунда',
  seconds: 'секунди',
  second_one: 'секунда',
  second_other: 'секунди',
  minute: 'минутa',
  minutes: 'минути',
  minute_one: 'минутa',
  minute_other: 'минути',
  hour: 'час',
  hours: 'часа',
  hour_one: 'час',
  hour_other: 'часа',
  day: 'ден',
  day_one: 'ден',
  day_other: 'дни',
  start_date: 'Начална дата',
  end_date: 'Крайна дата',
  from_date: 'От дата',
  to_date: 'До дата',
  avg_from_date: '(Средна) от дата',
  avg_to_date: '(Средна) до дата',
  period: 'Период',
  description: 'Описание',
  date: 'Дата',
  number: 'Номер',
  apply: 'Приложи',
  update: 'Обнови',
  create: 'Създай',
  delete: 'Изтрий',
  export: 'Експорт',
  rssi: 'rssi',
  ber: 'ber',
  reading: 'Отчет',
  model: 'Модел',
  email_address: 'Имейл адрес',
  password: 'Парола',
  confirm_password: 'Потвърди Парола',
  sign_in: 'Вписване',
  graph: 'Графика',
  no_data: 'Няма данни',
  every: 'Всеки',
  for_company: 'За компания',
  flow: 'Поток',
  no_data_found: 'Няма намерени данни.',
  percent: 'Процент',
  device_number_devicenum: 'Команди за устройство с номер: {{device_number}}',
  device_number: 'Команди за устройство с номер',
  device_name: 'Име на устройството',
  successfully_saved: 'Успешно запазено',
  error_occured: 'Възникна грешка',
  none: 'Няма',
  off: 'Изкл',
  no_unit: 'Без мерна единица',
  software_version: 'Версия на софтуер',
  hardware_version: 'Версия на хардуер',
  transmission_period: 'Период на предаване',
  record_period: 'Период на запис',
  replacement_number: 'Заместващ номер',
  replaced_by: 'Заместен от',

  createdOn: 'Създадено на',
  createdBy: 'Създадено от',

  show_average: 'Покажи средно',
  show_readings: 'Показване на показанията',

  yes: 'Да',
  no: 'Не',
  capital_yes: 'ДА',
  capital_no: 'НЕ',

  sensor: 'Сензор',

  all_sensors: 'Всички сензори',

  select_all: 'Избери всички',
  deselect_all: 'Премахни всички',

  function_last: 'Last',
  function_first: 'First',
  function_avg: 'Average',
  function_min: 'Min',
  function_max: 'Max',
  function_median: 'Median',
  function_count: 'Count',
  function_last_flow: 'Last Flow',
  function_first_flow: 'First Flow',
  function_avg_flow: 'Average Flow',
  function_max_flow: 'Max Flow',
  function_min_flow: 'Min Flow',
  function_median_flow: 'Median Flow',

  page_title_header_number_with_name_absent: '{{title}} - {{device_number}}',
  page_title_header_number_with_name_present: '{{title}} - {{device_name}} ({{device_number}})',

  error_forbidden_operation_not_allowed: 'Не е разрешено',

  not_set: 'Не е зададено',

  //Sensor Types
  generic_analog_sensor: 'Общ аналогов сензор',
  generic_virtual_sensor: 'Общ виртуален сензор',
  generic_digital_sensor: 'Общ цифров сензор',
  modbus_generic_analog_sensor: 'Модбъс общ аналогов сензор',
  modbus_generic_digital_sensor: 'Модбъс общ цифров сензор',
  pressure_sensor: 'Сензор за налягане',
  temperature_sensor: 'Сензор за температура',
  humidity_sensor: 'Сензор за влажност',
  level_sensor: 'Сензор за ниво',
  weight_meter: 'Измервател на тегло',
  weight_sensor: 'Сензор за тежест',
  load_cells: 'Товарни клетки',
  wind_direction_sensor: 'Сензор за посока на вятъра',
  barometric_pressure_sensor: 'Сензор за барометрично налягане',
  soil_moisture_sensor: 'Сензор за влага в почвата',
  dew_point_sensor: 'Сензор за точка на оросяване',
  soil_temperature_sensor: 'Сензор за температура на почвата',
  soil_potential_sensor: 'Сензор за потенциал на почвата',
  particulate_matter_sensor: 'Сензор за прахови частици',
  leaf_wetness_sensor: 'Сензор за влажност на листата',
  gnss_sensor: 'GNSS сензор',
  water_meter: 'Водомер',
  power_meter: 'Електромер',
  gas_flow_meter: 'Газов разходомер',
  rain_sensor: 'Сензор за дъжд',
  wind_speed_sensor: 'Сензор за скорост на вятъра',
  heat_meter: 'Топломер',
  geiger_mueller_counter: 'Гайгеров брояч',
  on_off_sensor: 'Сензор Вкл./Изкл.',
  on_off_input_sensor: 'Сензор Вход Вкл./Изкл.',
  on_off_output_sensor: 'Сензор Изход Вкл./Изкл.',
  on_off_auto_output_sensor: 'Сензор Изход Вкл./Изкл./Авт.',
  tasmota_relay_sensor: 'Сензор Tasmota Реле',
  modbus_generic_on_off_input_sensor: 'Модбъс общ сензор Вход Вкл./Изкл.',
  modbus_generic_on_off_output_sensor: 'Модбъс общ сензор Изход Вкл./Изкл.',
  co_sensor: 'CO сензор',
  no2_sensor: 'NO2 сензор',
  so2_sensor: 'SO2 сензор',

  //Port Types
  digital_input_port: 'Порт за цифров вход',
  pulse_input_port: 'Импулсен входен порт',
  pulse_s0_input_port: 'Импулсен С0 входен порт',
  analog_input_port: 'Порт за аналогов вход',
  '4_20_mA_input_port': '4-20mA входен порт',
  '0_5_V_input_port': '0-5V входен порт',
  on_off_input_port: 'Вкл./Изкл. входен порт',
  on_off_output_port: 'Вкл./Изкл. изходен порт',
  generic_modbus_on_off_input_port: 'Общ модбъс входен порт Вкл./Изкл.',
  generic_modbus_on_off_output_port: 'Общ модбъс изходен порт Вкл./Изкл.',

  // duration
  duration_years_one: '{{count}} година',
  duration_years_other: '{{count}} години',
  duration_months_one: '{{count}} месец',
  duration_months_other: '{{count}} месеца',
  duration_months_abbr: 'м.',
  duration_days_one: '{{count}} ден',
  duration_days_other: '{{count}} дни',
  duration_hours_one: '{{count}} час',
  duration_hours_other: '{{count}} часа',
  duration_minutes_one: '{{count}} минута',
  duration_minutes_other: '{{count}} минути',
  duration_seconds_one: '{{count}} секунда',
  duration_seconds_other: '{{count}} секунди',

  years: 'Години',
  months: 'Месеци',
  days: 'Дни',

  /*
   * |===============|
   * | Period Picker |
   * |===============|
   */
  period_date_range: 'Времеви период',
  period_custom: 'Персонализиран',
  period_today: 'Днес',
  period_week: 'Седмица',
  period_month: 'Месец',
  period_yesterday: 'Вчера',
  period_last_week: 'Минала седмица',
  period_last_month: 'Минал месец',
  period_last_1_hours: 'Последен час',
  period_last_2_hours: 'Последни 2 часа',
  period_last_4_hours: 'Последни 4 часа',
  period_last_24_hours: 'Последни 24 часа',
  period_last_48_hours: 'Последни 48 часа',

  /*
   * |=====================|
   * | Hook Error Messages |
   * |=====================|
   */
  error_cannot_fetch_device: 'Устройството не можа да бъде извлечено.',
  error_cannot_fetch_device_config: 'Конфигурацията на устройството не можа да бъде извлечена.',
  error_cannot_fetch_ports_config: 'Конфигурацията на портовете не можа да бъде извлечена.',
  error_cannot_fetch_flow_stats: 'Не можа да се извлече статистика за потока.',
  error_cannot_fetch_time_stats: 'Не можа да се извлече статистика за времето.',
  error_cannot_fetch_general_stats: 'Не можа да се извлече обща статистика.',
  error_cannot_fetch_qflow_stats: 'Не можа да се извлече статистика за qflow.',

  signup_company_name: 'Име на Компанията',

  sign_up_form_first_name: 'Първо име',
  sign_up_form_last_name: 'Фамилия',
  sign_up_form_email: 'Имейл Адрес',
  sign_up_form_password: 'Парола',
  sign_up_form_confirm_password: 'Потвърди Парола',
  sign_up_form_company_name: 'Име на Компанията',

  button_save: 'Запис',
  button_apply: 'Приложи',
  button_update: 'Обнови',
  button_create: 'Създай',
  button_delete: 'Изтрий',
  button_continue: 'Продължи',
  button_back: 'Назад',
  dashboard_tour_back: 'Назад',
  dashboard_tour_next: 'Напред',
  dashboard_tour_finish: 'Приключи',
  dashboard_tour_close: 'Затвори',
  dashboard_tour_open: 'Отвори диалог',
  dashboard_tour_skip: 'Пропусни',
  dashboard_tour_next_with_progress: 'Напред ({current} от {total})',
  capital_add_btn: 'ДОБАВИ',
  capital_create_btn: 'СЪЗДАЙ',
  capital_update_btn: 'ОБНОВИ',
  capital_remove_btn: 'ИЗТРИЙ',
  capital_cancel_btn: 'ОТКАЗ',

  role_roles: 'Роли',
  role_user: 'Потребител',
  role_public: 'Публичен',
  role_admin: 'Администратор',
  role_billing: 'Фактуриране',
  role_super_admin: 'Супер Администратор',
  role_restricted: 'Ограничен',

  device_counters_cumulative_graph_graph: 'Графика, номер на устройството: {{device_number}}',
  device_counters_cumulative_graph_must_have_analog_sensor:
    'Трябва да има активиран аналогов сензор.',

  confirm_registration_welcome_to_thingslog: 'Добре дошли в Thingslog!',
  confirm_registration_completed: 'РЕГИСТРАЦИЯ ЗАВЪРШЕНА',
  confirm_registration_failed: 'РЕГИСТРАЦИЯТА СЕ ПРОВАЛИ',
  confirm_registration_completed_description:
    'Процесът ви на регистрация е завършен. Можете да влезете сега. Ако се сблъскате с проблем, свържете се с нашата поддръжка на ',
  confirm_registration_failed_description:
    'Срещнахме проблем с регистрацията. Ако срещнете проблеми с влизането, моля, свържете се с нашата поддръжка на ',
  confirm_registration_visit_website: 'Посетете Нашият Уебсайт',
  confirm_registration_visit_ecommerce: 'Посетете Нашия Онлайн Магазин',

  sensor_statistics_min: 'Мин: {{min}}',
  sensor_statistics_max: 'Макс: {{max}}',
  sensor_statistics_avg: 'Ср: {{avrg}}',
  sensor_statistics_total: 'Общо: {{total}}',

  chart_statistics_min: 'Мин:',
  chart_statistics_max: 'Макс:',
  chart_statistics_avg: 'Ср:',
  chart_statistics_total: 'Общо:',

  menu_main: 'Основно',
  menu_device: 'Устройство',

  submenu_devices: 'Устройства',
  submenu_account: 'Акаунт',
  submenu_device_reports: 'Отчети на устройството',
  submenu_settings: 'Настройки',

  link_selected_device: 'Избрано устройство',
  link_device_nodes: 'Устройствени възли',
  link_devices: 'Списък с устройства',
  link_accounts: 'Акаунти',
  link_utility_rate: 'Тарифи',
  link_link_device: 'Свържи устройство',
  link_create_user: 'Създай потребител',
  link_icons: 'Икони',
  link_licenses: 'Лицензи',
  link_accounts_manager: 'Създай акаунт',
  link_transmissions: 'Предавания',
  link_map: 'Карта',
  link_inventory: 'Инвентар',
  link_devices_manager: 'Управление на устройства',
  link_battery: 'Батерия',
  device_groups: 'Групи устройства',
  link_signal: 'Сигнал',
  link_alarms: 'Аларми',
  link_value_ranges: 'Прагови диапазони',
  link_device_account_lookup: 'Търсене устройството в акаунти',
  link_dashboard: 'Начално табло',
  link_dashboard_2: 'Начално табло 2',
  link_reports: 'Справки',
  link_scheduled_reports: 'Планирани Справки',
  link_billing_report: 'Фактура за плащане',

  link_all_devices: 'Всички устройства',
  link_readings: 'Отчети',
  link_sensors_data: 'Данни на сензорите',
  link_flow: 'Поток',
  link_graph: 'Графика',
  link_new_graph: 'Бърза Графика',
  link_pump_control: 'Управление на помпа',
  link_relay_control: 'Управление на реле',
  link_alarm_config: 'Конфигуриране на Аларми',
  link_statistics: 'Статистики',
  link_customer: 'Клиент',
  link_meter: 'Уред',
  link_config: 'Синхронизация на конфигурацията',
  link_initial_config: 'Начална Конфигурация (старо)',
  link_sensor_config: 'Конфигуриране на Сензор (старо)',
  link_sensors_and_network_config: 'Конфигурация на параметри',
  link_export: 'Експорт',
  link_customer_billing_report: 'Отчет за таксуване на клиенти',
  link_flow_generator: 'Генератор на поток',
  link_show_users: 'Потребители',
  link_commands: 'Команди',
  link_copy_config: 'Копиране Конфигурация',
  switch_to_new_menu_label: 'Използвай новото меню',
  switch_to_old_menu_label: 'Използвай старото меню',

  link_profile: 'Профил',
  link_language: 'Език',
  link_sign_out: 'Изход',

  chip_early_access: 'Ранен Достъп',

  devices_table_number: 'Номер',
  devices_table_name: 'Име',
  devices_table_device_number: 'Номер на устройство',
  devices_table_device_name: 'Име на устройство',
  devices_table_business_partner: 'Бизнес партньор',
  devices_table_quarter: 'Квартал',
  devices_table_address: 'Адрес',
  devices_table_error: 'Не може да зареди устройствата',
  devices_table_no_devices_found: 'Не бяха открити устройства',
  devices_table_description: 'Описание',
  devices_column_header_search: 'Търсене…',

  pulse_sensor_1: 'Импулсен сензор 1',
  pulse_sensor_2: 'Импулсен сензор 2',
  analog_sensor_1: 'Аналогов Сензор 1',
  analog_sensor_2: 'Аналогов Сензор 2',
  analog_sensor_3: 'Аналогов Сензор 3',
  analog_sensor_4: 'Аналогов Сензор 4',
  analog_sensor_5: 'Сензор 1',
  analog_sensor_6: 'Сензор 2',
  analog_sensor_7: 'Сензор 3',
  analog_sensor_8: 'Сензор 4',
  on_off_sensor_1: 'Вкл/Изкл Сензор 1',
  on_off_sensor_2: 'Вкл/Изкл Сензор 2',
  on_off_sensor_3: 'Вкл/Изкл Реле 1',
  on_off_sensor_4: 'Вкл/Изкл Реле 2',

  device_icon: 'Икона на устройство',
  sensor_icon: 'Икона на сензор',
  icon_no_icon: 'Няма Икона',
  icon_barometer: 'Барометър',
  icon_door_closed: 'Врата Затворена',
  icon_door_open: 'Врата Отворена',
  icon_electricity: 'Електричество',
  icon_energy_meter: 'Измервател на Енергия',
  icon_gas_flow_meter: 'Разходомер на Газ',
  icon_gas: 'Газ',
  icon_generic_particle_meter: 'Общ Измервател на Частици',
  icon_generic: 'Общ',
  icon_heat_meter: 'Топломер',
  icon_humidity: 'Влажност',
  icon_leaf_moisture: 'Влага на Листата',
  icon_level_metering: 'Измерване на Ниво',
  icon_pivot: 'Шарнирен Болт',
  icon_pressure: 'Налягане',
  icon_radiation: 'Радиация',
  icon_rain: 'Дъжд',
  icon_soil_moisture: 'Влажност на Почвата',
  icon_temperature: 'Температура',
  icon_water_meter: 'Водомер',
  icon_water: 'Вода',
  icon_wind_direction: 'Посока на Вятъра',
  icon_wind_speed: 'Скорост на Вятъра',
  icon_pump: 'Помпа',
  icon_apartment: 'Жилищна Сграда',
  icon_base_station: 'Базова станция',
  icon_clinic: 'Клиника',
  icon_hospital: 'Болница',
  icon_house: 'Къща',
  icon_mayor_office: 'Кметство',
  icon_police_station: 'Полицейски участък',
  icon_public_restroom: 'Обществена тоалетна',
  icon_stadium: 'Стадион ',
  icon_gas_station: 'Бензиностанция',
  icon_controller: 'Контролер',

  device_icon_new_portal: 'Икона (нов портал)',
  device_icon_old_portal: 'Икона (стар портал)',

  very_low_level_alarm: 'Аларма за много ниско ниво',
  low_level_alarm: 'Аларма за ниско ниво',
  high_level_alarm: 'Аларма за високо ниво',
  very_high_level_alarm: 'Аларма за много високо ниво',

  sensor_conversion_formula: 'Формула за преобразуване на сензора',
  delete_old_counters: 'Изтриване на старите отчети',
  device_config_select_record_period: 'Изберете период за запис',
  device_config_select_transmission_period: 'Изберете период за предаване',

  alarm_config_header: 'Конфигуриране на аларми',
  alarm_config_notification_email: 'Имейл адреси за уведомление',
  alarm_config_notification_email_place_holder: 'Списък с имейл адреси (разделени със запетая)',
  alarm_config_missed_transmission_email: 'Имейл адреси за пропуснати предавания',
  alarm_config_missed_transmission_email_place_holder:
    'Списък с имейл адреси за пропуснати предавания (разедлени със запетая)',
  alarm_config_high_consumption_threshold:
    'Праг за голяма консумация за период на предаване {{transmission_every}} {{transmission_period}} [{{units}}]',
  alarm_config_low_flow_alarm_threshold: 'Праг за малък поток [{{units}}]',
  alarm_config_high_flow_alarm_threshold: 'Праг за голям поток [{{units}}]',
  alarm_config_non_zero_consumption_time_range: 'Времеви интервал за не-нулева консумация',
  alarm_config_high_low_flow_time_range: 'Времеви интервал за голям/малък поток',
  alarm_config_flow_calc_time_base: 'Времева база за изчисляване на потока',
  alarm_config_start_time: 'Начален час',
  alarm_config_end_time: 'Краен час',
  alarm_config_saved_msg: 'Конфигурацията е записана',
  alarm_config_email_validation_error:
    'Моля, въведете валидни имейл адреси, разделени с една запетая и без интервал, с максимална дължина от 255 символа.',

  alarm_config_non_zero_consumption_time_range_error: 'Трябва да има начално и крайно време',
  alarm_config_low_flow_severity: 'Сериозност на нисък поток',
  alarm_config_high_flow_severity: 'Сериозност на висок поток',
  alarm_config_high_consumption_severity: 'Сериозност на високо потребление',
  alarm_config_all_zero_severity: 'Сериозност на нулево потребление',
  alarm_config_non_zero_consumption_severity: 'Сериозност на ненулево потребление',
  alarm_config_on_off_severity: 'Сериозност на включване/изключване',

  alarms_title: 'Аларми',
  alarms_title_with_dev_num: 'Аларми, номер на устройството: {{device_number}}',
  alarms_type: 'Тип Аларма',
  alarms_active_status: 'Активност',
  alarms_active_dropdown_label: 'Активна',
  alarms_inactive_dropdown_label: 'Неактвина',

  device_battery_title: 'Ниво на батерията',
  device_battery_voltage: 'Напрежение, mV',
  device_battery_level: 'Ниво, %',

  device_signal_title: 'Сила на сигнал',

  device_counters_graph_header: 'Графика на потреблението',

  device_instant_graph_header: 'Бърза Графика',

  devices_signal_title: 'Сигнал на устройствата',
  devices_signal_level: 'Ниво на сигнала',
  devices_signal_level_percent: 'Ниво, %',

  devices_battery_title: 'Нива на батериите',
  devices_battery_level: 'Ниво на батерията, %',
  devices_battery_voltage: 'Напрежение, mV',

  reports_export_title: 'Извличане на отчети в файл',

  device_counter_export_title: 'Извличане на отчети в файл, номер на устройство: {{device_number}}',

  device_config_record_and_transmission_period: 'Период на запис и предаване',
  device_config_record_period: 'Период на запис',
  device_config_transmission_period: 'Период на предаване',
  device_config_start_setup: 'Конфигурирай',
  device_config_setup_message:
    'Конфигурацията е записана. Поставете магнит върху вашето устройство.',
  device_config_header: 'Конфигуриране на устройство',
  device_config_config_date: 'Дата на конфигуриране: {{date}}',
  device_config_config_status: 'Статус',
  device_config_config_status_configured: 'Синхронизирано',
  device_config_config_status_not_configured: 'Несинхронизирано',
  device_config_time_zone: 'Времева зона',
  device_config_pulse_per: '{{x}} на импулс',
  device_config_sensor_type: 'Тип Сензор',
  device_config_meter_type: 'Тип Измервателен Уред',
  device_config_select_time_zone: 'Изберете часова зона',
  device_config_missed_transmission_alarm_severity:
    'Сериозност на алармата за пропуснато предаване',
  device_config_pulse_coef_not_changed_message:
    'Внимание: Персонализираният "Пулсов коефициент" остава непроменен при промяна на "Начален отчет"',
  device_config_does_not_support_this_model:
    'Този модел на устройството не се поддържа на тази страница.',

  device_digits_fraction: 'Дробни',
  device_digits_digits: 'Цифри',
  device_digits_initial_reading: 'Начален отчет',
  device_digits_alert_too_many_total_digits: 'Общия брой цифри трябва да е <= 9',
  device_digits_alert_too_small_total_digits: 'Общия брой цифри трябва да е >= 4',
  device_digits_alert_too_many_total_fraction:
    'Общия брой цифри след запетаята трябва да е <= 3 и общия брой цифри трябва да е <= 9',
  device_digits_alert_too_small_total_fraction:
    'Общия брой цифри след запетаята трябва да е >=0 и общия брой цифри трябва да е >= 4',

  device_transmissions_at: 'Предавания на устройства в {{query_date}}',
  device_transmissions_last_transmission_short: 'Последно Пред.',
  device_transmissions_next_transmissions_short: 'Следващо Пред.',
  device_transmissions_days: 'Дни',
  device_transmissions_transmissions_short: 'Пред.',
  device_transmissions_count: 'Брой',
  device_transmissions_fail: 'Неуспешно',
  device_transmissions_customer: 'Клиент',
  device_transmissions_address: 'Адрес',
  device_transmissions_ok: 'Ок',

  link_device_link_device_to_my_account: 'Свързване на устройство с моя акаунт',
  link_device_device_number: 'Номер на Устройството',
  link_device_unlink_device: 'Прекрати Връзката',
  link_device_with_device_number: `Свързване на устройство: {{device_number}}`,
  unlink_device_with_device_number: `Прекратяване на връзката: {{device_number}}`,
  link_device_devices_counts:
    'Свързани устройства: {{linked_devices_count}} / {{allowed_devices_count}}',
  link_device_success_message: 'Устройството е свързано успешно',
  unlink_device_success_message: 'Устройството е премахнато успешно от: ',
  link_device_enter_device_number_error: 'Въведете номер на устройство',
  link_device_select_company_error: 'Изберете компания',
  link_device_default_error: 'Възникна проблем при свързването/развързването на устройството',
  link_device_company_not_found_error: 'Компанията не беше намерена',
  link_device_device_not_found_error: 'Устройство {{device_number}} не беше намерено',
  link_device_device_not_linked_error: 'Устройство {{device_number}} не е свързано',
  link_device_device_already_linked_error: 'Устройство {{device_number}} вече е свързано',
  link_device_device_limit_reached_error: 'Достигнат е лимитът на устройства',
  link_device_operation_not_allowed_error: 'Забранена операция',
  link_device_unlink_devices_for_sub_accounts: 'Премахни устройството за всички подакаунти',
  link_device_unlink_devices_for_sub_accounts_tooltip:
    'Ако е маркирано, устройството ще бъде премахнато от избрания акаунт и всички подакаунти. Ако не е маркирано, устройството ще бъде премахнато само за избрания акаунт.',
  link_device_lookup_title: 'Търсене на устройство',
  link_device_lookup_subheader:
    'Кликнете върху ред в тази таблица, за да попълните автоматично номера на устройството във формата за свързване.',
  link_device_lookup_filter_number: 'Номер',
  link_device_lookup_filter_name: 'Име',
  link_device_lookup_device_name: 'Име на устройство',
  link_device_lookup_device_number: 'Номер на устройство',
  link_device_lookup_no_devices_found: 'Няма намерени устройства',

  device_search_device_number: 'Номер на Устройството',
  device_search_kicker: 'Контекст на компанията',
  device_search_title: 'Търсене на компания по устройство',
  device_search_subtitle:
    'Потърсете по номер на устройство и изберете компанията, която да остане активна в management.',
  device_search_device_number_placeholder: 'Въведете номер на устройство',
  device_search_length_hint: 'Търсенето започва автоматично, след като спрете да пишете.',
  device_search_clear: 'Изчисти',
  device_search_selected_company: 'Избрана компания',
  device_search_selected_company_hint:
    'Натиснете същия ред отново, за да премахнете текущия избор на компания.',
  device_search_error: 'Неуспешно зареждане на компаниите за този номер на устройство.',
  device_search_no_matches: 'Няма намерени компании за този номер на устройство.',
  device_search_results_title: 'Съвпадащи компании',
  device_search_results_ready: 'Изберете ред, за да смените активния контекст на компанията.',
  device_search_results_waiting: 'Въведете номер на устройство, за да започне търсенето.',
  device_search_empty_prompt: 'Въведете номер на устройство, за да търсите съвпадащи компании.',
  device_search_empty_prompt_subtitle: 'Резултатите ще се покажат тук, след като спрете да пишете.',
  device_search_domain: 'Домейн',

  device_manager_create_or_delete_device:
    'Създаване или изтриване на устройство: {{device_number}}',
  device_manager_device_number: 'Номер на Устройството',
  device_manager_device_model: 'Модел на Устройството',
  device_manager_sw_version_validation:
    'Изискваният формат е X.X.X или X.X.X- и X.X.X_, последвани от символи, където X е число.',
  device_manager_hw_version_validation: 'Изискваният формат е X.X.X където X е число.',
  device_manager_software_version: 'Версия на софтуера',
  device_manager_hardware_version: 'Версия на хардуера',

  dashboard_alarms: 'Аларми',
  dashboard_batteries: 'Батерии',
  dashboard_signal: 'Сигнал',
  dashboard_transmission: '{{alarm_type}} ({{alarm_count}})',
  dashboard_chart_battery_level: 'Ниво на батерията',
  dashboard_chart_signal_level: 'Ниво на сигнала',
  dashboard_chart_number_of_devices: 'Брой устройства',
  dashboard_select_company_header: 'Изберете акаунт за да видите началното табло',
  dashboard_select_company_from: 'От тук: ',
  dashboard_select_company_accounts_page_link: 'Акаунти',

  alarm_type_no_zero_consumption: 'Не Нулева Консумация',
  alarm_type_high_consumption: 'Висока Консумация',
  alarm_type_high_flow: 'Висок Поток',
  alarm_type_missed_transmission: 'Пропуснато Предаване',
  alarm_type_low_flow: 'Нисък Поток',
  alarm_type_all_zero_consumption: 'Нулева Консумация',
  alarm_type_device_removed: 'Устройството е Премахнато',
  alarm_type_on_off_alarm: 'Вкл/Изкл Аларма',
  alarm_type_low_level: 'Ниско Ниво',
  alarm_type_high_level: 'Високо Ниво',
  alarm_type_tamper: 'Тампер',
  alarm_type_oversized: 'Твърде Голям',
  alarm_type_undersized: 'Твърде Малък',
  alarm_type_low_battery: 'Изтощена Батерия',
  alarm_type_blockage: 'Блокирано',
  alarm_type_burst: 'Спукано',
  alarm_type_reverse_flow: 'Обратен Поток',
  alarm_type_range_event: 'Излизане От Диапазон',
  alarm_type_very_low_level: 'Много Ниско Ниво',
  alarm_type_very_high_level: 'Много Високо Ниво',
  alarm_type_leakage: 'Теч',
  alarm_type_low_temperature: 'Ниска Температура',
  alarm_type_no_consumption: 'Без Консумация',
  alarm_type_negative_flow: 'Отрицателен Поток',
  alarm_type_empty_spool: 'Празна Тръба',
  alarm_type_combination_of_alarms: 'Комбинация От Аларми',
  alarm_type_standstill: 'Без Движение',
  alarm_type_reset_error: 'Грешка При Рестарт',
  alarm_type_rf_error: 'RF Грешка',
  alarm_type_cs_error: 'CS Грешка',
  alarm_type_measuring_error: 'Грешка При Измерване',
  alarm_type_reset_event: 'Рестарт',
  alarm_type_magnetic_field: 'Магнитно Поле',
  alarm_type_sensor_fraud: 'Манипулация На Сензора',

  device_counter_graph_min: 'Мин: {{min}}',
  device_counter_graph_max: 'Макс: {{max}}',
  device_counter_graph_avg: 'Ср: {{avrg}}',
  device_counter_graph_total: 'Общо: {{total}}',
  device_counter_graph_average: 'Средно Aритметично:',
  device_counter_graph_no_data: 'Няма данни',
  device_counter_graph_cant_calculate_flow_analog:
    'Не може да се изчисли поток за аналогов сензор!',
  device_counter_graph_must_have_digital_sensor: 'Трябва да има активиран цифров сензор.',

  customer_info_header: 'Информация за клиента',
  customer_info_business_partner_number: 'Номер на бизнес партньор',
  customer_info_contact_data: 'Данни за Kонтакт',
  customer_info_contract_number: 'Номер на клиентски договор',
  customer_info_name: 'Име',
  customer_info_description: 'Описание',
  customer_info_billing_group: 'Група за фактуриране',
  customer_info_municipality: 'Община',
  customer_info_quarter: 'Квартал',
  customer_info_street: 'Улица',
  customer_info_block: 'Блок',
  customer_info_entr: 'Вход',
  customer_info_customer_type: 'Тип клиент',
  customer_info_customer_type_commercial: 'Търговски',
  customer_info_customer_type_domestic: 'Вътрешни',
  customer_info_customer_type_block_of_flats: 'Жилищен Блок',
  customer_info_customer_type_budget: 'Бюджет',

  meter_info_meter_info: 'Информация за измервателния уред: {{device_number}}',
  meter_info_factory_number: 'Фабричен Номер',
  meter_info_brand: 'Марка',
  meter_info_enter_diameter: 'Въведете Диаметър',
  meter_info_mount_date: 'Дата на Монтиране',
  meter_info_meter_info_saved: 'Информация за измервателния уред е запазена.',

  device_initial_config_header: 'Първоначална конфигурация на устройството',
  device_initial_device_model: 'Модел на устройството',
  device_initial_config_address: 'Адрес',
  device_initial_config_port: 'Порт',
  device_initial_config_resolve_address: 'Адрес за резолюция (използвайте DNS)',
  device_initial_config_simcard_provider: 'Доставчик на SIM карти',
  device_initial_config_simcard_number: 'Номер на SIM карта',
  device_initial_config_bands: 'bands',
  device_initial_config_OTAA_appkey: 'OTAA - appkey',
  device_initial_config_OTAA_deveui: 'OTAA - deveui',
  device_initial_config_OTAA_appeui: 'OTAA - appeui',
  device_initial_config_ABP_appskey: 'ABP - appskey',
  device_initial_config_ABP_nwkskey: 'ABP - nwkskey',
  device_initial_config_ABP_devaddr: 'ABP - devaddr',
  device_initial_config_ABP_deveui: 'ABP - deveui',
  device_initial_config_lora_app_mode: 'Режим на работа',
  device_initial_config_app_id: 'ID на приложение',
  device_initial_config_profile_id: 'ID на профил',
  device_initial_config_platform_name: 'Име на платформата',
  device_initial_config_thingslog_lora_platform: 'ThingsLog LoRa платформа',
  device_receive_data_binary: 'Получаване на двоични данни',
  device_send_data_binary: 'Изпращане на двоични данни',
  device_mqtt_config: 'MQTT конфигурация',
  device_mqtt_config_qos: 'Качество на услугата',
  device_mqtt_config_username: 'Потребителско име',
  device_mqtt_config_password: 'Парола',
  device_mqtt_config_certificate: 'Сертификат',
  device_initial_config_apn_username: 'APN Потребителско име',
  device_initial_config_apn_password: 'APN Парола',
  device_initial_config_gprs_radio_mode: 'Режим на GPRS',
  device_initial_config_grps_radio_mode_auto_option: 'Автоматичен',
  device_initial_config_net_attached_delay: 'Време за изчакване',
  device_initial_config_preferred_network_type: 'Предпочитан Тип Мрежа',
  device_initial_config_preferred_network_default_option: 'По подразбиране',
  device_initial_config_mcc_mnc: 'MCC-MNC',
  device_initial_config_slave_devices: 'Slave Устройства',
  device_initial_config_modbus_address: 'Modbus Адрес',
  device_initial_config_modbus_master_device: 'Master устройство',
  device_initial_config_trashcan_brand: 'Марка',
  device_initial_config_trashcan_model: 'Модел',
  device_initial_config_trashcan_volume: 'Обем',
  device_initial_config_trashcan_max_weight: 'Максимално тегло',
  device_initial_config_trashcan_material: 'Материал',
  device_initial_config_trashcan_color: 'Цвят',
  device_initial_config_trashcan_waste_type: 'Тип отпадъци',
  device_initial_config_trashcan_waste_type_plastic: 'Пластмаса',
  device_initial_config_trashcan_waste_type_bio: 'Био',
  device_initial_config_trashcan_waste_type_paper: 'Хартия',
  device_initial_config_trashcan_waste_type_glass: 'Стъкло',
  device_initial_config_trashcan_waste_type_metal: 'Метал',
  device_initial_config_trashcan_waste_type_mixed: 'Смесени',
  device_initial_config_trashcan_waste_type_other: 'Други',
  device_initial_config_trashcan_pricing: 'Ценообразуване',
  device_initial_config_trashcan_pricing_free: 'Безплатно',
  device_initial_config_trashcan_pricing_per_lift: 'На извозване',
  device_initial_config_trashcan_pricing_per_kg: 'На килограм',
  device_initial_config_trashcan_pricing_per_subscription: 'На абонамент',
  device_initial_config_trashcan_placement: 'Разположение',
  device_initial_config_trashcan_placement_on_the_street: 'На улицата',
  device_initial_config_trashcan_placement_inside: 'Вътре',
  device_initial_config_trashcan_placement_backyard: 'Двор',
  device_initial_config_trashcan_customer_community_id: 'ID на клиентска общност',
  device_initial_config_trash_truck_brand: 'Марка',
  device_initial_config_trash_truck_plate_number: 'Регистрационен номер',
  device_initial_config_trash_truck_model: 'Модел',
  device_initial_config_find_encryption_key_by_device_number:
    'Намиране на шифровал ключ по номер на устройство',

  sensor_config_header: 'Конфигурация на сензори',
  sensor_config_name: 'Име',
  sensor_config_sensor_name: 'Име на сензора',
  sensor_config_sensor_icon: 'Име на икона',
  sensor_config_description: 'Описание',
  sensor_config_model: 'Модел',
  sensor_config_serial_number: 'Сериен номер',
  sensor_config_manufacturer: 'Производител',
  sensor_config_diameter: 'Диаметър',
  sensor_config_price: 'Цена',
  sensor_config_currency: 'Валута',
  sensor_config_supported_visualization_types: 'Поддържани видове визуализация',
  sensor_config_port_type: 'Тип Порт',
  sensor_config_port_type_digital_input_port: 'Порт за Цифров Вход',
  sensor_config_port_type_analog_input_port: 'Порт за Аналогов Вход',
  sensor_config_port_type_pulse_s0_input_port: 'Импулсен С0 Входен Порт',
  sensor_config_port_type_pulse_input_port: 'Импулсен Входен Порт',
  sensor_config_port_type_on_off_input_port: 'Вкл Изк Входен Порт',
  sensor_config_port_type_on_off_output_port: 'Вкл Изк Изходен Порт',
  sensor_config_port_conversion_formula: 'Формула за Преобразуване на Портове',
  sensor_config_formula: 'Формула',
  sensor_config_offset: 'Офсет',
  sensor_config_sensor_index_tooltip: 'Сензорен индекс: {{sensor_index}}',
  sensor_config_visible: 'Видимост',
  sensor_config_order_number: 'Номер на поръчка',
  sensor_config_visible_true: 'Видим',
  sensor_config_visible_false: 'Скрит',
  sensor_config_use_in_sensor_aggregation: 'Използване при агрегиране на сензори',
  sensor_config_use_in_sensor_aggregation_true: 'Използвай',
  sensor_config_use_in_sensor_aggregation_false: 'Не използвай',
  sensor_config_value_labels: 'Етикети на стойности',
  sensor_config_label_for_value_zero: 'Етикет за стойност "0"',
  sensor_config_label_for_value_one: 'Етикет за стойност "1"',
  sensor_config_inverted_read_state_value: 'Обърнатo четене',
  sensor_config_inverted_read_state_value_true: 'Обърнато',
  sensor_config_inverted_read_state_value_false: 'Нормално',
  sensor_config_register_address: 'Адрес на регистъра',
  sensor_config_data_type: 'Тип данни',
  sensor_config_count: 'Брой',
  sensor_config_number_registers: 'Брой регистри',
  sensor_config_particle_size: 'Размер на частиците',
  sensor_config_power: 'Мощност',
  sensor_config_measurement_type: 'Тип на измерване',
  sensor_config_measurement_group: 'Група на измерване',
  tasmota_generic_digital_sensor: 'Tasmota общ цифров сензор',
  tasmota_alarm_input_sensor: 'Tasmota входен алармен сензор',
  tasmota_generic_analog_sensor: 'Tasmota общ аналогов сензор',

  device_counter_statistics_statistics_id: 'Статистика, id: {{device_number}}, {{description}}',
  device_counter_statistics_quarter: 'Тримесечие',
  device_counter_statistics_flow: 'Поток',
  device_counter_statistics_hour: 'Час',
  device_counter_statistics_quantity: 'Количество',
  device_counter_statistics_value: 'Стойност',
  device_counter_statistics_digital_ports_must_be_present:
    'Трябва да имате импулсен вход свързан със сензор за водомер, за да видите тази таблица.',
  device_counter_statistics_name_must_have_initialized_value:
    'Параметри Q3, R и Диаметър се изискват на импулсен вход свързан със сензор за водомер.',

  company_manager_title: 'Създаване и изтриване на акаунт: {{company_name}}',
  company_manager_account_name: 'Име на акaунта',
  company_manager_solution: 'Вид на проекта',
  company_manager_solution_option_none: 'Незададен',
  company_manager_solution_option_agri: 'Аграрен',
  company_manager_solution_option_air_quality: 'Чистота на въздуха',
  company_manager_solution_option_street_lights: 'Улично осветление',
  company_manager_solution_option_pump_station: 'Помпена станция',
  company_manager_solution_option_smart_waste: 'Умни отпадъци',
  company_manager_solution_option_level: 'Мониторинг на ниво',
  company_manager_solution_option_gas: 'Мониторинг на газ',
  company_manager_solution_option_pressure: 'Мониторинг на налягане',
  company_manager_solution_option_smart_water: 'Умна вода',
  company_manager_solution_option_environment_monitoring: 'Мониторинг на околната среда',
  company_manager_solution_option_energy: 'Мониторинг на енергия',
  company_manager_license: 'Лиценз',
  company_manager_account: 'Акаунт',
  company_manager_create_company: 'Създай акаунт',
  company_manager_create_company_error: 'Имаше проблем при създаването на вашият акаунт',
  company_manager_license_info_box:
    'Прикачването на лиценз изисква валиден идентификатор на акаунт. Проверете два пъти стойността на вашия идентификатор на акаунт, ако искате да го включите в процеса на създаване.',
  company_manager_valid_from: 'Валидно от',
  company_manager_valid_to: 'Валидно до',
  company_manager_license_per_device: 'На устройство',
  company_manager_license_per_reading: 'На отчет',
  company_manager_license_per_sensor: 'На сензор',
  company_manager_license_per_poc: 'На доказателство за концепция (POC)',
  company_manager_license_per_remote_node: 'На отдалечен възел (node)',
  company_manager_solution_type: 'Тип решение',
  company_manager_contact_id: 'Номер на контакт',
  company_manager_account_id: 'Номер на акаунт',
  company_manager_license_type: 'Тип на лиценза',
  company_manager_timezone: 'Часова зона',
  company_manager_country: 'Държава',
  company_manager_countries_error: 'Не можаха да се заредят държавите',
  company_manager_timezones_error: 'Не можаха да се заредят часовите зони',
  company_manager_account_info: 'Информация за акаунта',
  company_manager_address: 'Адрес',
  company_manager_city: 'Град',
  company_manager_municipality: 'Община',
  company_manager_area: 'Район',
  company_manager_zip_code: 'Пощенски код',
  company_manager_vat_number: 'ДДС номер',
  company_manager_account_ext_number: 'Външен номер на акаунта',
  company_manager_account_ext_type: 'Външен тип акаунт',
  company_manager_account_ext_type_none: 'Няма',
  company_manager_account_ext_type_household: 'Домакинство',
  company_manager_account_ext_type_business: 'Бизнес',

  company_manager_creating_account: 'Създаване на акаунта: {{company_name}}',
  company_manager_deleting_account: 'Изтриване на акаунта: {{company_name}}',
  company_manager_account_created: 'Акаунта е създаден успешно',
  company_manager_account_deleted: 'Акаунта е изтрит успешно',

  company_manager_update_company: 'Актуализиране на акаунта',
  company_manager_delete_company: 'Изтриване на акаунта',
  company_manager_actions: 'Действия',
  company_manager_delete_modal_description:
    'Сигурни ли сте, че искате да изтриете тази компания, действието е необратимо?',
  company_manager_confirm_button: 'Потвърди',
  company_manager_cancel_button: 'Откажи',
  company_manager_delete_company_error_message: 'Възникна грешка при изтриването на акаунта',
  company_manager_update_btn: 'Актуализирай',
  company_manager_child_company_warning_message: 'Създаване на подакаунт на',
  company_manager_current_logged_in_company: 'акаунта, в който сте влезли в момента',
  company_manager_current_selected_company: 'акаунта, който в момента сте избрали',

  accounts_child_companies: 'Подкомпании',
  accounts_contactRef: 'Номер на контакт',
  accounts_externalNumber: 'Външен номер',
  accounts_accountRef: 'Номер на акаунт',
  accounts_logo: 'Лого',
  accounts_info_unavailable: 'Няма информация за тази сметка.',
  company_manager_accountRef_is_disabled_because_of_license_type:
    'Акаунт номера не е съвместим с POC лиценз.',
  accounts_none: 'Няма',
  company_manager_update_company_success: 'Акаунта е актуализиран успешно',
  company_manager_update_company_error: 'Възникна грешка при актуализирането на акаунта',
  company_manager_account_name_exists: 'Акаунт с това име вече съществува.',

  license_manager_title: 'Актуализиране на лиценз: {{company_name}}',
  license_manager_license: 'Лиценз',
  license_manager_license_updated: 'Лицензът е обновен',

  companies_title: 'Брой акаунти: {{company_number}}',
  companies_table_name: 'Име',
  companies_number_of_accounts: 'Брой акаунти:',
  companies_search: 'Търсене',

  users_title: 'Потребители',
  units_type: 'Мерна единица',
  reports_export_format_type: 'Формат',

  login_form_forgot_password: 'Forgot password?',

  pump_auto_every: 'Авто всеки {{secs}} сек',
  pump_svg_last_updated: 'Последно обновен: {{timestamp}}',
  pump_svg_power_supply: 'Захранване',
  pump_svg_water_level_controller: 'Контролер помпа',
  pump_svg_pump: 'Помпа',
  pump_svg_level_sensor: 'Нивомер',
  pump_svg_pump_on_sensor: 'Пускане на помпа',
  pump_svg_pump_off_sensor: 'Спиране на помпа',
  pump_svg_dry_run_sensor: 'Сензор критично ниво',

  device_groups_error_please_select_company: 'Моля, изберете акаунт.',

  device_groups_btn_add: 'Добави',
  device_groups_btn_edit: 'Редактирай',
  device_groups_btn_delete: 'Изтрий',
  device_groups_btn_cancel: 'Прекрати',
  device_groups_tooltip_edit: 'Редактирай',
  device_groups_tooltip_delete: 'Изтрий',
  device_groups_color_picker_label: 'Цвят на групата',

  device_groups_name: 'Име',
  device_groups_devices: 'Устройства',
  device_groups_view_devices: 'Виж {{count}} устройства',
  device_groups_group_name: 'Име на групата',
  device_groups_parent_device_group: 'Родителска група от устройства',
  device_groups_auto_device_group_type_label: 'Автоматична група устройства',
  device_groups_auto_device_group_type_none: 'Без автоматична група',
  device_groups_auto_device_group_type_all_devices: 'Всички устройства',
  device_groups_auto_device_group_type_all_water: 'Всички водомери',
  device_groups_auto_device_group_type_all_energy: 'Всички енергийни устройства',
  device_groups_auto_device_group_type_all_pressure: 'Всички сензори за налягане',
  device_groups_auto_device_group_type_all_barometric_pressure:
    'Всички сензори за барометрично налягане',
  device_groups_auto_device_group_type_all_levels: 'Всички нивомери',
  device_groups_auto_device_group_type_all_soil_moisture: 'Всички сензори за влажност на почвата',
  device_groups_auto_device_group_type_all_air_humidity: 'Всички сензори за влажност на въздуха',
  device_groups_auto_device_group_type_all_temperatures: 'Всички температурни сензори',
  device_groups_auto_device_group_type_all_pm10: 'Всички PM10 сензори',
  device_groups_auto_device_group_type_all_pm2_5: 'Всички PM2.5 сензори',
  device_groups_auto_device_group_type_unknown: 'Неизвестна автоматична група',
  device_groups_auto_device_group_alert_title: 'Активирана е автоматична група устройства',
  device_groups_auto_device_group_alert_description: 'Тази група е конфигурирана като {{type}}.',
  device_groups_auto_device_group_change: 'Промени',
  device_groups_auto_device_group_change_modal_title: 'Промяна на автоматичната група устройства',
  device_groups_menuitem_none: 'Без',
  device_groups_add_device_group: 'Добавяне група от устройства',
  device_groups_edit_device_group: 'Редактиране група от устройства',
  device_groups_delete_device_group: 'Изтриване група от устройства',

  device_grous_add_sensor_device: 'Добавяне на сензор и устройство към група',

  device_groups_table_sensor_group_name_header: 'Име на сензорната група',
  device_groups_table_parent_group_name_header: 'Име на родителската група',
  device_groups_table_device_count_header: 'Брой устройства',

  device_groups_sensor_table_device_number_header: 'Номер на устройство',
  device_groups_sensor_table_sensor_name_header: 'Име на сензор',
  device_groups_sensor_table_sensor_index_header: 'Индекс на сензор',
  device_groups_sensor_table_select_message: 'Избери сензорна група',

  device_groups_sensors_add_modal_device_placeholder: 'Номер на устройство',
  device_groups_sensors_add_modal_sensor_placeholder: 'Сензор',
  device_groups_sensors_add_modal_device_group_name_required: 'Изисква се име на група',

  device_groups_sensors_delete_description:
    'Ако изтриете тази конфигурация, тя ще бъде премахната перманентно от сървъра.',
  device_groups_device_group_delete_description:
    'Ако изтриете тази група, тя ще бъде премахната перманентно от сървъра.',

  device_groups_select_company_header: 'Изберете компания за да продължите',
  device_groups_select_company_from: 'От тук: ',
  device_groups_select_company_accounts_page_link: 'Акаунти',

  device_groups_create_device_group_error:
    'Възникна проблем при създаването на нова група устройства',
  device_groups_update_device_group_error:
    'Възникна проблем при актуализирането на групата устройства',
  device_groups_delete_device_group_error: 'Възникна проблем при изтриването на групата устройства',
  device_groups_add_device_sensor_device_group_error: 'Възникна проблем при добавянето на сензора',
  device_groups_remove_device_sensor_device_group_error:
    'Възникна проблем при премахването на сензора',

  /*
   * |==============|
   * | Users Config |
   * |==============|
   */

  //Page
  users_header: 'Потребители',
  users_table_username: 'Потребителско име',
  users_table_first_name: 'Име',
  users_table_last_name: 'Фамилия',
  users_table_company_name: 'Акаунт',
  users_table_email: 'Имейл',

  //Filters
  users_filter_username: 'Филтриране Потребителско име',
  users_filter_first_name: 'Филтриране Име',
  users_filter_last_name: 'Филтриране Фамилия',
  users_filter_email: 'Филтриране Email',
  users_filter_company_name: 'Филтриране Акаунт',
  users_reset_filter_icon: 'Изчисти филтрите',
  users_table_is_contact_person: 'Лице за контакт',

  //Modals
  users_add_modal_header: 'Добави Потребител',
  users_update_modal_header: 'Обнови Потребителя',
  user_remove_modal_icon: 'Изтрий потребител',
  users_remove_modal_header: 'Сигурни ли сте, че искате да изтриете потребителя {{username}}?',
  users_remove_modal_body:
    'Кликането върху изтрий ще изтрие за постоянно избрания потребител от сървъра',
  users_is_dashboard_enabled: 'Активиране на портал',
  users_is_contact_person: 'Контактно лице',

  //Errors
  users_password_match: 'Паролите не съвпадат',
  users_email_blank: 'Email не може да е празен',
  users_load_error: 'Не можаха да се заредят потребителите',
  users_update_error: 'Не може да се актуализира потребителят',
  users_delete_error: 'Не може да се изтрие потребителят',
  users_create_error: 'Не може да се създаде потребител',

  // Success
  users_update_success: 'Потребителят е актуализиран успешно',
  users_delete_success: 'Потребителят е изтрит успешно',
  users_create_success: 'Потребителят е създаден успешно',
  /*
   * |=====================|
   * | Value Ranges Config |
   * |=====================|
   */

  // Buttons & tooltips
  value_ranges_btn_add: 'Добави',
  value_ranges_btn_defaults: 'По подразбиране',
  value_ranges_line_color: 'Цвят на линията',
  value_ranges_node_color: 'Цвят на възела',
  value_ranges_foreground_color: 'Цвят на преден план',
  value_ranges_background_color: 'Цвят на фона',
  value_ranges_loading: 'Зареждане...',
  value_ranges_nothing_to_show: 'Няма данни за показване',

  //Page
  value_ranges_header: 'Прагови диапазони',
  value_ranges_trigger: 'Задейства',
  value_ranges_notifications: 'Известия',
  value_ranges_before: 'Преди',
  value_ranges_after: 'След',
  value_ranges_disabled: 'Изключен',
  value_ranges_date_range: 'Oбхват на датата',
  value_ranges_daily_time_slot: 'Дневен интервал',
  value_ranges_timezone: 'Часова зона',

  //Modals
  value_ranges_add_event: 'Добавяне на събитие',
  value_ranges_edit_event: 'Редактиране на събитие',
  value_ranges_add_default_events: 'Добавяне на събитие по подразбиране',
  value_ranges_remove_modal_header: 'Сигурни ли сте, че искате да изтриете диапазон от стойности',
  value_ranges_remove_modal_body:
    'Щракването върху премахване ще изтрие избрания диапазон от стойности',

  //Form
  value_range_form_name: 'Име на събитието',
  value_range_form_function: 'Функция',
  value_range_form_sensor: 'Сензор',
  value_range_form_description: 'Описание',
  value_range_form_min: 'Мин',
  value_range_form_max: 'Макс',
  value_range_form_severity: 'Сериозност',
  value_range_form_start_day: 'Начален ден',
  value_range_form_start_month: 'Начален месец',
  value_range_form_start_time: 'Начален час',
  value_range_form_end_day: 'Краен ден',
  value_range_form_end_month: 'Краен месец',
  value_range_form_end_time: 'Краен час',
  value_range_form_enable_events: 'Активиране на събития?',
  value_range_form_select_color: 'Избран цвят',
  value_range_form_notification_email: 'Електронна поща',
  value_range_form_notification_push_notification: 'Телефонно известие',
  value_range_form_notification_sms: 'СМС',
  value_range_form_notification_push: 'Известие',
  value_range_form_notification_call: 'Обаждане',
  value_range_form_line_custom_color: 'Персонализиран цвят на линията',
  value_range_form_marker_custom_color: 'Персонализиран цвят на маркера',
  value_range_form_no_notifications: 'Без известия',

  //Errors

  value_range_tooltip_severity:
    'Сериозността, която е по-голяма от 7, се счита за сериозна. Сериозните събития се отбелязват с удивителен знак.',
  value_range_error_add: 'Неуспешно добавяне на събитие',
  value_range_error_edit: 'Събитието не може да се редактира',
  value_range_name_is_required: 'Името е задължително',
  value_range_name_already_exists: 'Името на събитието вече съществува за това устройство и сензор',
  value_range_name_incorect_time: 'Неправилен формат на час',
  value_range_min_greater_than_max: 'Мин не може да бъде по-голям от макс',
  value_range_min_equal_to_max: 'Мин не може да бъде равен на макс',
  value_range_min_max_is_required: 'Изисква се Мин или макс',
  value_range_error_occured: 'Възникна грешка',
  value_range_start_incorrect_time:
    'Началният час има неправилен формат. Трябва да е HH:mm. Правилно: 01:00. Неправилно: 1:00.',
  value_range_end_incorrect_time:
    'Крайният час има неправилен формат. Трябва да е HH:mm. Правилно: 01:00. Неправилно: 1:00.',
  value_range_start_day_missing_start_month: 'Началният ден трябва да има начален месец',
  value_range_end_day_missing_end_month: 'Крайният ден трябва да има краен месец',
  value_range_start_month_missing_start_day: 'Началният месец трябва да има начален ден',
  value_range_end_month_missing_end_day: 'Крайният месец трябва да има краен ден',
  value_range_mixed_alphabets_error:
    'Засечена употреба на смесени азбуки, използвайте само един език',

  /*
   * |==========|
   * | Commands |
   * |==========|
   */

  // Command State
  commands_command_state_pending: 'Изчакваща',
  commands_command_state_sent: 'Изпратена',
  commands_command_state_cancelled: 'Отменена',
  commands_command_state_status_ok: 'Ок',
  commands_command_state_status_nok: 'Не е ок',
  commands_command_state_unknown: 'Неизвестен',
  commands_command_state_timeout: 'Изчакването е изтекло',

  // Command Type
  commands_command_type_relay_switch: 'Управление Релейни Изходи',
  commands_command_type_single_relay_switch: 'Релеен Изход',
  commands_command_type_relay_switch_with_delay: 'Релейни Изходи с Отложен Старт',
  commands_command_type_relay_statuses: 'Релейни статуси',
  commands_command_type_send_config_over_mqtt: 'Прати конфигурация през MQTT',
  commands_command_type_send_date_over_mqtt: 'Прати дата през MQTT',
  commands_command_type_modbus: 'Модбъс',
  commands_command_type_tasmota_relay_switch: 'Tasmota команда за реле',
  commands_command_type_reset: 'Нулиране',
  commands_command_type_scheduled_relay_command: 'Планирана команда за реле',
  commands_command_type_scheduled_relay_command_4: 'Планирани команди за реле (4)',

  // Errors
  commands_error_missing_device_number: 'Номерът на устройството липсва или е грешно.',

  // Buttons
  commands_btn_send_command: 'Изпрати команда',
  commands_btn_submit: 'Изпращане',
  commands_btn_refresh: 'Обнови',

  // Tooltips
  commands_tooltip_edit: 'Редактирай',

  // Popups
  commands_send_command: 'Изпрати Команда',
  commands_edit_command: 'Редактирай Команда',
  commands_command_type: 'Вид Команда',
  commands_parameters: 'Параметри',
  commands_parameter_name: 'Име на параметър',
  commands_parameter_value: 'Стойност на параметър',

  // Page
  commands_header: 'Команди',
  commands_type: 'Вид Команда',
  commands_status: 'Статус',
  commands_relay_1_status: 'Реле 1 Статус',
  commands_relay_2_status: 'Реле 2 Статус',
  commands_created: 'Създадена',
  commands_sent: 'Изпратена',
  commands_executed: 'Изпълнена',
  commands_relay_status: 'Статус на реле',
  commands_relay_index: 'Индекс на реле',

  commands_sensor_index: 'Индекс на сензор',
  commands_slave_device_number: 'Номер на подчинено устройство',
  commands_hour: 'Час',
  commands_minutes: 'Минути',
  commands_auto_refresh: 'Автоматично обновяване',
  commands_no_commands: 'Към това устройство все още не са изпращани команди.',
  commands_no_parameters: 'Тази команда не приема параметри.',
  commands_no_parameter_values: 'Няма налични стойности за това устройство.',
  commands_schedule_group: 'График {{index}}',
  commands_cancel_command: 'Отказ на командата',
  commands_cancel_command_confirm:
    'Тази команда още не е изпратена. Отказът ѝ спира доставянето ѝ до устройството.',
  commands_cancel_command_success: 'Командата е отказана',
  commands_send_command_success: 'Командата е изпратена',
  commands_btn_close: 'Затвори',
  commands_btn_keep: 'Запази я',
  commands_parameters_empty: 'Няма параметри',
  commands_command_id: 'ИД',
  commands_error_send_failed: 'Командата не можа да бъде изпратена.',
  commands_error_cancel_failed: 'Командата не можа да бъде отказана.',
  commands_error_parameters_failed: 'Параметрите за тази команда не можаха да бъдат заредени.',
  commands_only_pending_can_be_cancelled: 'Могат да се отказват само чакащи команди.',
  commands_last_updated: 'Обновено в {{time}}',
  commands_error_list_failed: 'Командите не можаха да бъдат заредени.',
  commands_range_hint: 'Позволено: {{min}}–{{max}}',

  /*
   * |=============|
   * | Copy Config |
   * |=============|
   */

  // Page
  copy_config_copy_config: 'Копиране Конфигурация',
  copy_config_to_device_number_with_name_absent: 'Към устройство: {{device_number}}',
  copy_config_to_device_number_with_name_present:
    'Към устройство: {{device_name}} ({{device_number}})',
  copy_config_from_device_number: 'От Номер на Устройство',
  copy_config_copy_config_type_label: 'Тип копиране',
  copy_config_existing_device_option: 'Съществуващо устройство',
  copy_config_new_device_option: 'Ново устройство',
  copy_config_should_copy_label: 'Ще копира:',
  copy_config_should_copy_config_option: 'Конфигурация',
  copy_config_should_copy_value_ranges_option: 'Прагови диапазони',

  // Buttons
  copy_config_btn_copy: 'Копирай',

  //Toast
  copy_config_toast_copied_success: 'Конфигурацията на устройството е копирана успешно.',
  copy_config_toast_copied_error: 'Възникна проблем при копиране конфигурацията на устройството.',
  copy_config_value_ranges_toast_copied_success: 'Праговите диапазони са копирани успешно.',
  copy_config_value_ranges_toast_copied_error:
    'Възникна проблем при копиране на праговите диапазони.',

  /*
   * |============|
   * | Statistics |
   * |============|
   */
  statistics_header: 'Статистика',
  statistics_header_hours: 'Часа',
  statistics_header_quantity: 'Количество',
  statistics_header_value: 'Стойност',
  statistics_quantity_minimum: 'Минимум',
  statistics_quantity_maximum: 'Максимум',
  statistics_quantity_average: 'Средно аритметично',
  statistics_quantity_total: 'Обща сума',
  statistics_quantity_hours: 'Часа',
  statistics_quantity_counters: 'Броячи',
  statistics_error_title: 'Статистиката не е налична',
  statistics_error_missing_config_title: 'Конфигурацията на водомера е непълна',
  statistics_error_missing_config_description:
    'За да се изчисли статистиката, диаметър, q3 и r трябва да са зададени за всеки водомер. Прегледайте текущите стойности по-долу и попълнете липсващите.',
  statistics_error_missing_field: 'Липсва {{field}}',
  statistics_error_not_defined: 'Не е зададено',
  statistics_error_open_sensor_config: 'Отвори конфигурацията на сензорите',
  statistics_error_update_values_hint:
    'Попълнете липсващите стойности и се върнете на тази страница.',
  statistics_error_contact_admin:
    'Моля, свържете се с администратор и го помолете да зададе липсващите стойности за конфигурацията на водомера.',
  statistics_error_flow_unit_not_configured: 'Избраният сензор няма зададена единица за дебит.',

  // Error
  statistics_error_definition_for_q3:
    'Сензорът {{name}} не съдържа дефиниция за q3. Моля, посетете страницата за конфигурация на сензора.',
  statistics_eror_definition_for_diameter:
    'Сензорът {{name}} не съдържа дефиниция за диаметър. Моля, посетете страницата за конфигурация на сензора.',
  statistics_error_definition_for_r:
    'Сензорът {{name}} не съдържа дефиниция за r. Моля, посетете страницата за конфигурация на сензора.',
  statistics_error_no_water_meters_found:
    'Не са намерени водомери. Моля, посетете страницата за конфигурация на устройството.',

  /*
   * |=====|
   * | Map |
   * |=====|
   */
  map_add_device: 'Добави {{device}}',
  map_edit_device: 'Редактирай {{device}}',
  map_lat: 'Географска ширина',
  map_long: 'Географска дължина',
  map_coordinates: 'Координати',
  map_polygon: 'Полигон',
  map_linked_in_polygons: 'В пологони:',
  map_loading: 'Зареждане...',

  // Button
  map_btn_link_device: 'Свържи устройство',
  map_btn_submit: 'Изпрати',

  // Error
  map_err_add_device_to_map: 'Не можа да се добави устройство към картата.',
  map_err_change_location: 'Не може да се промени местоположението.',
  map_err_link_polygon: 'Не можа да се свърже с полигон.',

  // Device Modal
  map_btn_get_curr_location: 'Вземи текущото местоположение',
  map_geolocation_not_supported: 'Геолокацията не се поддържа от този браузър.',
  map_lat_validation_message: 'Невалидна географска ширина',
  map_long_validation_message: 'Невалидна географска дължина',
  map_invalid_location: 'Невалидно местоположение',
  map_invalid_coordinate_input:
    'Невалидно въвеждане на координати. Трябва да е "lat, long", напр. 42.123, 23.123',

  // Set Coordinates Modal
  map_coordinates_modal_btn_label: 'Задай Координати',
  map_coordinates_modal_title: 'Задай Координати',
  map_coordinates_modal_target_option_self: 'За Себе Си',
  map_coordinates_modal_target_option_company: 'За Компанията',
  map_coordinates_modal_target_option_user: 'За Потребител',
  map_coordinates_modal_select_user_autocomplete_label: 'Потребителско Име',
  map_coordinates_modal_save_for_self_warning_message:
    'Запазването ще зададе текущите координати като стандартни за вашия текущ потребител. Сигурни ли сте, че искате да продължите?',
  map_coordinates_modal_save_for_company_warning_message:
    'Запазването ще зададе текущите координати като стандартни за всеки потребител във вашата компания. Сигурни ли сте, че искате да продължите?',
  map_coordinates_modal_save_for_user_warning_message:
    'Запазването ще зададе текущите координати като стандартни за избрания потребител. Сигурни ли сте, че искате да продължите?',
  map_coordinates_modal_confirm_btn_label: 'Потвърди',
  map_coordinates_modal_cancel_btn_label: 'Отказ',

  /*
   * |===============|
   * | Sensor Config |
   * |===============|
   */

  flow_time_units: 'Времеви единици',
  flow_measurement_units: 'Мерни единици',
  flow_configuration_label: 'Конфигурация на поток',
  flow_coefficient: 'Коефициент',
  sensor_config_sensor_group_name: 'Име на група сензори',
  flow_configuration_alert_message: 'Проверете следните конфигурации на потока:\n{{message}}',
  flow_configuration_invalid_sensor_row_message:
    'Индекс: {{sensor_index}} с име: {{sensor_name}}\n',
  flow_configuration_sensor_name_not_set_label: 'Не е зададено',

  /*
   * |===================|
   * | Device Prediction |
   * |===================|
   */
  device_prediction: 'Прогноза за устройството',
  device_prediction_header: 'Анализ на времеви серии',
  device_prediction_sensor_name: 'Име на сензор',
  device_prediction_forward_days: 'Дни напред',
  device_prediction_backward_days: 'Дни назад',
  device_prediction_generate_btn: 'Генерирай',
  device_prediction_error: 'Грешка',
  device_prediction_error_msg_json: 'Възникна проблем при генерирането на данни за прогнозата.',
  device_prediction_error_msg_image:
    'Възникна проблем при генерирането на изображение за прогнозата',
  device_prediction_date: 'Дата',
  device_prediction_trend: 'Тенденция',
  device_prediction_time: 'Време',
  device_prediction_legend_prediction: 'Прогноза',
  device_prediction_legend_range: 'Обхват на прогнозата',
  device_prediction_legend_consumption: 'Текуща консумация',

  device_prediction_help_title: 'Помощ',
  device_prediction_help_title_input_guide: 'Ръководство за Въвеждане',
  device_prediction_help_input_guide_text:
    '<strong> 1. Период </strong> - Потребителите могат да изберат времеви диапазон от предварително зададени опции или да зададат персонализиран диапазон. Системата анализира данните в този избран период, за да изчисли бъдещи прогнози, предоставяйки ценни идеи. <br> <strong> 2. Име на сензор </strong> – изберете сензора, чийто бъдещи прогнози искате да видите. <br> <strong> 3. Всеки </strong> - използва се за по-подробни прогнози по отношение на грануларността на времето. <br> <strong> 4. Дни напред </strong> - брой дни, в които потребителят иска да направи прогнози за бъдещето. Тези прогнози се разширяват извън избрания времеви диапазон и предоставят информация за очакваното поведение на консумацията. <br> <strong> 5. Дни назад </strong> - представлява броя дни, които да се показват на графиката и таблицата, като започват от последния ден от избрания период. Това показва истинските реални данни, получени от устройството по време на този определен период. <br> <strong> 6. Бутон "Генериране" </strong> – като кликнете върху "Генериране", системата изчислява консумацията въз основа на избраните настройки и генерира прогнози. Резултатите се показват както в изгледа на графиката, така и в изгледа на таблицата. <br> <strong> 7. Графика </strong> – Графиката показва как напредни, така и дни назад, като представя истинските получени данни и показва предсказаните данни. <br> <strong> 8. Таблица </strong> - Таблицата показва всички данни от "от периода" до края на "напредните дни". Всяко ред съдържа конкретна дата, време и съответна стойност на тенденцията, указваща общата насока или модел на данните във времето. Помага за разбиране дали стойностите нарастват, намаляват или се стабилизират по време на предсказания период.',
  device_prediction_help_title_legend: 'Легенда',
  device_prediction_help_black:
    '<strong> Черен цвят </strong> - представлява истинските данни за консумация по време на избрания период (пример: от 01 юли до 31 юли.)',
  device_prediction_help_red:
    '<strong> Червен цвят </strong> - Представлява истинската консумация, ако има данни извън избрания период. В горния изображение има реални данни, получени от устройството в дните, в които моделът е настроен да направи прогнози. Така потребителят може да сравни предсказаните стойности (тъмносини) с червените (реални данни)',
  device_prediction_help_dark_blue:
    ' <strong> Тъмносин цвят </strong> - Представлява прогнозата за избрания период, която включва стари данни и се разширява към бъдещето с предсказаните стойности за напредните дни. Тези предсказани стойности предоставят информация за очакваната тенденция на консумацията.',
  device_prediction_help_light_blue:
    '<strong> Светлосин цвят </strong> - Представлява обхвата на предсказаните стойности. Той указва, че истинските данни за консумация могат да се попаднат в този обхват, като показва несигурността, свързана с прогнозите.',
  device_prediction_help_example:
    "Когато 'ОТ' датата е зададена на 1 юли, 'ДО' датата на 31 юли, с 'Дни напред' 30, 'Дни назад' 30 и 'Всеки' 10 минути, графиката ще покаже 30-дневната реална консумация (от 1 юли до 1 август) и предсказаните стойности за 30 дни напред (от 1 август до 1 септември). Таблицата ще показва истинската и предсказаната консумация за всеки 10 минути от 1 юли до 1 септември",

  /*
   * |=================|
   * | Counters Export |
   * |=================|
   */

  // Buttons and dropdowns
  counters_export_header: 'Експортиране на данни',
  counters_readings_header: 'Отчети',
  counters_export_search: 'Търси',
  counters_export_download: 'Изтегли',
  counters_export_format: 'Формат',

  // Table columns
  counters_export_table_device_name: 'Име на устройството',
  counters_export_table_device_number: 'Номер на устройство',
  counters_export_table_sensor_index: 'Сензор индекс',
  counters_export_table_sensor_name: 'Сензор име',
  counters_export_table_date: 'Дата',
  counters_export_table_counters: 'Стойност',
  counters_export_table_prev_counters: 'Предишна стойност',
  counters_export_table_dt: 'Времева разлика',
  counters_export_table_delta: 'Разлика',
  counters_export_error_alert_message: 'Възникна грешка при генериране на данните.',
  counter_export_select_devices_label: 'Изберете устройства',
  counter_export_select_sensors_label: 'Изберете сензори',
  counter_export_sensor_index: 'Сензор индекс: {{sensor_index}}',

  counters_export_maximum_capacity_error_message: 'Максималният капацитет за експорт е достигнат!',
  counters_export_maximum_capacity_suggestion_message:
    'Моля намалете броят на устройствата или времевия период.',
  counters_export_empty_selection_title: 'Изберете какво да експортирате',
  counters_export_empty_selection_message:
    'Изберете едно или повече устройства или групи устройства, за да подготвите експорта на показания.',
  counters_export_ready_title: 'Изборът е готов',
  counters_export_ready_message:
    'Избрани са {{devicesCount}} устройства и {{groupsCount}} групи устройства. Натиснете Търсене за преглед на данните или Изтегляне за експорт.',
  counters_export_selected_device_toast: 'Избрано устройство: {{deviceNumber}}',
  /*
   * |====================|
   * | Consumption Export |
   * |====================|
   */

  // Buttons and dropdowns
  consumption_export_header: 'Справка',
  consumption_export_search: 'Търси',
  consumption_export_download: 'Изтегли',
  consumption_export_format: 'Формат',
  consumption_export_aggregation_period: 'Период на агрегиране',
  consumption_export_aggregation_options_none: 'Незададен',
  consumption_export_aggregation_options_daily: 'Дневен',
  consumption_export_aggregation_options_weekly: 'Седмичен',
  consumption_export_aggregation_options_monthly: 'Месечен',
  consumption_export_aggregation_options_yearly: 'Годишен',

  // Table columns
  consumption_export_table_device_number: 'Номер на устройство',
  consumption_export_table_sensor_index: 'Сензор индекс',
  consumption_export_table_address: 'Адрес',
  consumption_export_table_sensor_name: 'Сензор име',
  consumption_export_table_first_reading_date: 'Дата на първата стойност',
  consumption_export_table_first_reading_value: 'Първа стойност',
  consumption_export_table_last_reading_date: 'Дата на последната стойност',
  consumption_export_table_last_reading_value: 'Последна стойност',
  consumption_export_table_delta: 'Разлика',
  consumption_export_table_average: 'Средно аритметично',
  consumption_export_table_consumption_for_period: 'Консумация за период',
  consumption_export_empty_selection_title: 'Изберете какво да експортирате',
  consumption_export_empty_selection_message:
    'Изберете едно или повече устройства или групи устройства, за да подготвите експорта на консумация.',
  consumption_export_ready_title: 'Изборът е готов',
  consumption_export_ready_message:
    'Избрани са {{devicesCount}} устройства и {{groupsCount}} групи устройства. Натиснете Търсене за преглед на данните или Изтегляне за експорт.',
  consumption_export_selected_device_toast: 'Избрано устройство: {{deviceNumber}}',

  /*
   * |=================|
   * | Alarms Export |
   * |=================|
   */

  // Buttons and dropdowns
  alarms_export_header: 'Аларми',
  alarms_export_search: 'Търси',
  alarms_export_refresh: 'Обнови',
  alarms_export_download: 'Изтегли',
  alarms_export_format: 'Формат',

  alarms_return_to_alarms: 'Върнете се към Аларми',
  alarms_redirect_to_graph: 'Пренасочване към Графика',

  // Table columns
  alarms_export_table_date: 'Дата',
  alarms_export_table_device_number: 'Номер на устройство',
  alarms_export_table_device_name: 'Име на устройство',
  alarms_export_table_severity: 'Значимост',
  alarm_severity_tooltip: 'Значимост: {{value}} от 10',
  alarm_severity_none_tooltip: 'Няма отчетена значимост за тази аларма',
  alarms_export_table_sensor_index: 'Сензор индекс',
  alarms_export_table_sensor_name: 'Сензор име',
  alarms_export_table_alarm_type: 'Тип',
  alarms_export_table_alarm_status: 'Статус',
  alarms_export_table_description: 'Описание',
  alarms_export_table_link_to_graph: 'Връзка към графика',
  alarms_export_chip_status_active: 'Активен',
  alarms_export_chip_status_inactive: 'Неактивен',
  alarms_export_switch_title_label: 'Автоматично опресняване',
  alarms_export_error_alert_message: 'Възникна грешка при извличане на данните',
  alarms_export_select_company_alert_message: 'Изберете компания, преди да изтеглите алармите',
  alarms_export_select_device_or_company_alert_message:
    'Изберете устройство или компания, преди да изтеглите алармите',
  alarms_export_error_too_big_query:
    'Извличането на хронология от Супер администратор за всички устройства е твърде голяма заявка. Моля, изберете компания.',

  /*
   * |================|
   * | Inventory page |
   * |================|
   */

  //table
  device_inventory_page_header: 'Инвентар',
  device_inventory_column_header_search: 'Търсене…',
  device_inventory_description: 'Описание',
  device_inventory_device_name: 'Име на устройство',
  device_inventory_device_number: 'Номер на устройство',
  device_inventory_hardware_version: 'Версия на хардуер',
  device_inventory_model: 'Модел',
  device_inventory_software_version: 'Версия на софтуер',
  device_inventory_actions: 'Действия',
  nomenclature: 'Номенклатура',

  //modal
  device_inventory_manual: 'Ръчно',
  device_inventory_template: 'Шаблон',
  device_inventory_add_device: 'Добавяне на устройство',
  device_inventory_create_device_button: 'Създаване на устройство',
  device_inventory_delete_unlink_modal_body:
    'Това ще изтрие избраното устройство завинаги или можете да го разсвържете от избраната компания. Устройството ще бъде премахнато от текущия акаунт и всички подакаунти. Ако искате да премахнете устройството само от текущия акаунт, моля, посетете страницата "Свържи устройство".',
  device_inventory_delete_modal_body: 'Това ще изтрие завинаги избраното устройство.',
  device_inventory_hardware_version_helper: 'Изискваният формат е X.X.X, където X е число',
  device_inventory_update_device_button: 'Актуализиране на устройството',
  device_inventory_update_device_title: 'Актуализиране на устройство {{number}}',
  device_inventory_modal_delete_device_title: 'Изтриване на устройство {{number}}',
  device_inventory_software_version_helper:
    'Изискваният формат е X.X.X или X.X.X- и X.X.X_, последвани от знаци, където X е число',
  device_inventory_description_helper: 'Достигнат лимит за дължина на описанието',
  device_inventory_device_number_helper:
    'Моля, въведете 8 знака, съдържащи само букви (A-Z) и цифри (0-9).',
  device_inventory_modal_select_action: 'Изберете действие за устройство {{device_number}}',
  device_inventory_reference_device_number: 'Изберете устройство за връзка',
  device_inventory_nomenclature_required_for_model: 'Номенклатурата е задължителна за {{model}}',

  //success
  device_inventory_create_device_success: 'Устройството е успешно създадено',
  device_inventory_update_device_success: 'Устройството е успешно актуализирано',
  device_inventory_delete_device_success: 'Устройството е успешно изтрито',
  device_inventory_unlink_device_success: 'Устройството беше успешно премахнато от компанията',
  device_inventory_rma_add_success: 'RMA записът беше добавен успешно',
  device_inventory_rma_history_title: 'RMA История - {{number}}',
  device_inventory_rma_add_record: 'Добави запис',
  device_inventory_rma_no_records: 'Няма RMA записи за това устройство',
  device_inventory_rma_add_error: 'Възникна грешка при добавяне на RMA записа',
  rma_record_date: 'Дата',
  rma_record_date_required: 'Датата е задължителна',
  rma_record_type: 'Тип',
  rma_record_category: 'Категория',
  rma_record_comments: 'Коментари',
  rma_record_save: 'Запази',
  rma_record_back: 'Назад',
  rma_type_INCIDENT: 'Инцидент',
  rma_type_DEVICE_EVENT: 'Събитие на устройство',
  rma_type_RMA: 'RMA',
  rma_category_BATTERY_REPLACEMENT: 'Смяна на батерия',
  rma_category_SIM_CARD_CHANGE: 'Смяна на SIM карта',
  rma_category_ENCLOSURE_DEGRADATION: 'Износване на кутията',
  rma_category_FLOOD_DAMAGE: 'Щети от наводнение',
  rma_category_ANTENNA_REPLACEMENT: 'Смяна на антена',
  rma_category_POWER_SUPPLY_PROBLEM: 'Проблем със захранването',
  rma_category_PHYSICAL_DAMAGE: 'Физическа повреда',
  rma_category_STOLEN: 'Откраднато',
  rma_category_WRONG_CONFIGURATION: 'Грешна конфигурация',
  rma_category_OTHER: 'Друго',

  //error
  device_inventory_create_device_error: 'Възникна грешка при създаване на устройство',
  device_inventory_delete_device_error: 'Възникна грешка при изтриване на устройство',
  device_inventory_device_exists: 'Устройството вече съществува',
  device_inventory_empty_device_error: 'Номерът на устройството не може да бъде празен',
  device_inventory_empty_reference_error: 'Изберете устройство за връзка',
  device_inventory_empty_device_name_error: 'Името на устройството не може да бъде празно',
  device_inventory_empty_hardware_error: 'Версията на хардуера не може да бъде празна',
  device_inventory_empty_software_error: 'Версията на софтуера не може да бъде празна',
  device_inventory_error: 'Не може да се заредят устройствата',
  device_inventory_update_device_error: 'Възникна грешка при актуализиране на устройството',
  device_inventory_already_exists_error: 'Устройство с този номер вече съществува',
  device_inventory_empty_nomenclature_error: 'Номенклатурата не може да бъде празна',
  device_inventory_empty_manufacturing_date_error: 'Датата на производство не може да бъде празна',
  device_inventory_empty_warranty_period_error: 'Гаранционният период не може да бъде празен',

  /*
   * |====================|
   * | Transmissions page |
   * |====================|
   */

  //page
  transmissions_page_title: 'Предавания',
  transmissions_page_refresh: 'Опресняване',
  transmissions_page_export_csv: 'Експортиране в CSV',
  transmissions_page_error_message: 'Грешка при зареждане на предаванията',

  //table
  transmissions_table_device_number: 'Номер на устройството',
  transmissions_table_device_name: 'Име на устройството',
  transmissions_table_last_transmission: 'Последно предаване',
  transmissions_table_next_transmission: 'Следващо предаване',
  transmissions_table_days: 'Дни',
  transmissions_table_transmission: 'Предаване',
  transmissions_table_count: 'Брой',
  transmissions_table_customer: 'Клиент',
  transmissions_table_address: 'Адрес',
  transmissions_table_ok: 'OK',
  transmissions_table_devEUI: 'devEUI',
  transmissions_table_simcard_number: 'Номер на SIM карта',
  transmissions_table_simcard_provider: 'Доставчик на SIM карти',
  transmissions_table_apn: 'APN',

  /*
   * |===============|
   * | Device Config |
   * |===============|
   */

  // page
  device_config_period: 'Период',
  device_config_every: 'Всеки',

  // error
  device_config_error_record_period_postiive: 'Периодът на запис трябва да е положителен.',
  device_config_error_transmission_period_positive:
    'Периодът на предаване трябва да е положителен.',
  device_config_error_record_must_be_greater_than_transmission:
    'Периодът на запис не може да бъде по-дълъг от периода на предаване.',
  device_config_error_not_divisible: 'Периодът на запис не се дели на периода на предаване.',
  device_config_error_max_threshold_reached:
    '{{curr}} записа на предаване е повече от максимума {{max}}.',

  /*
   * |=======|
   * | Graph |
   * |=======|
   */
  graph_tabs_readings: 'Стойности',
  graph_tabs_prediction: 'Прогноза',
  graph_tabs_average: 'Средно',
  graph_tabs_previous: 'Предишен',
  graph_column_sensor: 'Сензор',
  graph_column_index: 'Индекс',
  graph_column_device: 'Устройство',
  graph_column_device_name: 'Име на устройството',
  graph_column_date: 'Дата',
  graph_column_readings: 'Стойност',
  graph_column_previous_readings: 'Предишна стойност',
  graph_column_delta: 'Разлика',
  /*
   * |===============|
   * | Settings page |
   * |===============|
   */
  settings_page_header: 'Настройки',
  settings_submit_success_msg: 'Настройките са запазени',
  settings_submit_error_msg: 'Настройките не можаха да бъдат запазени',
  settings_input_invalid_format_error_msg: 'Невалиден формат на данните',
  settings_certificate_not_found_error: 'Не беше открит сертификат на този файлов път',
  settings_add_button: 'Добави',
  settings_submit_button: 'Потвърди',
  settings_input_key_label: 'Ключ',
  settings_input_type_label: 'Тип',
  settings_input_value_label: 'Стойност',
  settings_select_type_string: 'Низ',
  settings_select_type_number: 'Число',
  settings_select_type_boolean: 'Булев',
  settings_select_type_object: 'Обект',
  settings_logo_label: 'Лого',
  settings_dashboard_layout_label: 'Оформление на дашборда',
  settings_certificate_label: 'Път до сертификата',
  settings_device_panel_title: 'Заглавие на панела за устройства',
  settings_sensor_panel_title: 'Заглавие на панела за сензори',
  settings_header_home_label: 'Заглавие на начало (Портал)',
  settings_header_dashboard_label: 'Заглавие на табло (Портал)',
  settings_footer_main_label: 'Основен надпис на футъра (Портал)',
  settings_footer_link_label: 'Надпис на връзка във футъра (Портал)',
  settings_footer_link_url: 'URL на връзка във футъра (Портал)',
  settings_alarm_notification_display_period:
    'Период на показване на алармени известия (часове) (Портал)',
  /* |===========|
   * | New Graph |
   * |===========|
   */

  //page
  new_graph_add_device_group_modal_title:
    'Конфигурация на "Всеки" за сензорите в групата устройства',
  new_graph_add_device_group_modal_device_group: 'Група устройства: ',
  new_graph_add_device_group_modal_sensors_to_add: 'Сензори за добавяне: ',
  new_graph_add_device_group_modal_every_selector_mode_per_device: 'На устройство',
  new_graph_add_device_group_modal_every_selector_mode_per_sensor: 'На сензор',
  new_graph_add_device_group_modal_sensor_limit_message:
    'Не можете да надвишите ограничението от {{graphSensorsLimit}} сензора за графиката!',
  new_graph_add_device_group_modal_confirm_button: 'Потвърди',
  new_graph_add_device_group_modal_cancel_button: 'Отказ',
  new_graph_select_sensor_heading: 'Изберете сензор',
  new_graph_date_range_selection: 'Изберете времеви период',
  new_graph_selected_sensors_heading: 'Избрани сензори',
  new_graph_selected_sensors_remove_all_tooltip: 'Изчисти всички',
  new_graph_select_company_message: 'Моля, изберете компания',
  new_graph_show_sensors_statistics_label: 'Покажи статистика',

  //sensor selection
  new_graph_device_group_label: 'Група устройства',
  new_graph_device_label: 'Устройство',
  new_graph_sensor_label: 'Сензор',

  //date range selection
  new_graph_average_days_label: 'Дни за средно аритметично',
  new_graph_time_series_prediction_period_label: 'Период',
  new_graph_auto_refresh_label: 'Обновяване',
  new_graph_period_picker_heading: 'Период',
  new_graph_average_days_heading: 'Средно аритметично',
  new_graph_time_series_prediction_period_heading: 'Прогноза',
  new_graph_none_option: 'Незададен',
  new_graph_day_option_one: `{{count}} ден`,
  new_graph_day_option_other: `{{count}} дни`,
  new_graph_week_option_one: '{{count}} седмица',
  new_graph_week_option_other: '{{count}} седмици',
  new_graph_month_option_one: '{{count}} месец',
  new_graph_month_option_other: '{{count}} месеца',
  new_graph_year_option_one: '{{count}} година',
  new_graph_year_option_other: '{{count}} години',

  //tooltip
  new_graph_current_value_name: 'Текуща',
  new_graph_average_value_name: 'Средна',
  new_graph_prediction_value_name: 'Прогноза',

  //error
  new_graph_fetch_device_groups_error: 'Не може да се заредят групи устройства за компанията.',
  new_graph_fetch_devices_error: 'Не може да се заредят устройства за компанията.',
  new_graph_fetch_device_config_error:
    'Не може да се зареди конфигурацията на избраното устройство.',
  new_graph_fetch_device_ports_config_error:
    'Не може да се заредят портовете за избраното устройство.',
  new_graph_fetch_device_flow_error: 'Не може да се зареди поток на устройство {{deviceName}}.',
  new_graph_fetch_device_flow_avg_error:
    'Не може да се зареди среден поток на устройство {{deviceName}}.',
  new_graph_fetch_device_readings_error:
    'Не може да се заредят отчитанията за устройство {{deviceName}}.',
  new_graph_fetch_device_readings_avg_error:
    'Не може да се заредят средните отчитанията за устройство {{deviceName}}.',
  new_graph_fetch_device_on_off_alarms_error:
    'Не може да се заредят вкл/изкл аларми за устройство {{deviceName}}.',
  new_graph_fetch_device_prediction_error: 'Не може да се зареди прогноза за {{deviceName}}.',
  new_graph_sensor_already_in_state_error: 'Избраният сензор вече фигурира в списъка.',

  /* |================|
   * | Billing Report |
   * |================|
   */

  billing_report_header: 'Справка за плащане',
  billing_report_btn_generate: 'Генериране',
  billing_report_device_number: 'Номер на устройството',
  billing_report_first_reading_date: 'Дата на първото отчитане',
  billing_report_last_reading_date: 'Дата на последното отчитане',
  billing_report_readings: 'Отчитания',
  billing_report_battery: 'Батерия',
  billing_report_signal: 'Сигнал',
  billing_report_total: 'Общо',

  /* |================|
   * | Profile Page   |
   * |================|
   */
  profile_page_change_logo: 'Промени лого',
  profile_page_logo_formats_message: 'Приемливи формати: PNG, JPEG',
  profile_page_name: 'Име',
  profile_page_email: 'Имейл',
  profile_page_language: 'Език',
  profile_page_password: 'Парола',
  profile_page_change_language: 'Промени езика',
  profile_page_update_license: 'Актуализация на лиценза',
  profile_page_change_password: 'Промяна на паролата',
  profile_page_generate: 'Генерирай',
  profile_page_api_token: 'API Токен',
  profile_page_client_id: 'Client ID',
  profile_page_client_secret: 'Client Secret',
  profile_page_show_client_id: 'Покажи client ID',
  profile_page_hide_client_id: 'Скрий client ID',
  profile_page_show_client_secret: 'Покажи client secret',
  profile_page_hide_client_secret: 'Скрий client secret',
  profile_page_api_token_label: 'API Токен',
  profile_page_api_token_valid_for: 'Валиден за {{duration}}.',
  profile_page_copy: 'Копирай',
  profile_page_copied_to_clipboard: 'Копирано в клипборда.',
  profile_page_failed_to_copy: 'Неуспешно копиране в клипборда.',
  profile_page_token_generated_success: 'Токенът е генериран успешно.',
  profile_page_token_generate_error: 'Неуспешно генериране на токен.',
  profile_page_header: 'Профил',
  profile_page_user_info_label: 'Информация за потребителя',
  profile_page_license_label: 'Лиценз ',
  profile_page_license_type: 'Тип на лиценза',
  profile_page_valid_from: 'Валиден от',
  profile_page_valid_to: 'Валиден до',
  profile_page_max_readings: 'Максимален брой отчети',
  profile_page_current_count: 'Текущ брой',
  profile_page_first_reading: 'Първо отчитане',
  profile_page_last_reading: 'Последно отчитане',
  profile_page_license_status: 'Статус',
  profile_page_renew_license_button: 'Поднови Лиценз',
  profile_page_deactivate_license_button: 'Деактивирай Лиценз',
  profile_page_valid_license: 'Валиден лиценз',
  profile_page_invalid_license: 'Невалиден лиценз',
  profile_page_deactivate_license_success_message: 'Лицензът е деактивиран.',
  profile_page_deactivate_license_error_message: 'Не можа да се деактивира лицензът.',
  profile_page_deactivate_modal_title: 'Деактивация на лиценз',
  profile_page_confirm_button: 'Потвърди',
  profile_page_cancel_button: 'Отказ',
  profile_page_deactivate_license_modal_description:
    'Сигурни ли сте, че искате да деактивирате този лиценз?',
  profile_page_activate_license_modal_description:
    'Сигурни ли сте, че искате да активирате този лиценз?',
  profile_page_activate_modal_title: 'Активация на лиценз',
  profile_page_license_per_device: 'на устройство',
  profile_page_license_per_reading: 'на отчет',
  profile_page_license_per_sensor: 'на сензор',
  profile_page_license_per_poc: 'на доказателство за концепция (POC)',
  profile_page_license_per_remote_node: 'на отдалечен възел',
  profile_page_license_partial: 'частичен',
  profile_page_logo_file_format_error: 'Невалиден тип файл. Моля, качете изображение.',
  profile_page_logo_size_error:
    'Размерът на файла надвишава 1MB. Моля, качете по-малко изображение.',
  profile_page_version_info: 'Текущи версии:',

  profile_page_country: 'Държава',
  profile_page_timezone: 'Часова зона',
  profile_page_address: 'Адрес',
  profile_page_city: 'Град',
  profile_page_municipality: 'Община',
  profile_page_area: 'Район',
  profile_page_zip_code: 'Пощенски код',
  profile_page_vat_number: 'ДДС номер',
  profile_page_edit: 'Редактиране на акаунта',
  profile_page_update_account_success: 'Акаунтът е актуализиран успешно',
  profile_page_license_info: 'Информация за лиценз',

  logo_error_message: 'Не можа да се зареди логото на компанията',
  /* |===============|
   * | Utility Rates |
   * |===============|
   */

  // table
  util_rates: 'Тарифи',

  util_rates_name: 'Име',
  util_rates_price: 'Цена',
  util_rates_currency: 'Валута',
  util_rates_unit: 'Мерна единица',
  util_rates_private: 'Частно',
  util_rate_company: 'Компания',
  util_rate_created: 'Създаден',
  util_rates_updated: 'Актуализиран',
  util_rates_actions: 'Действия',
  util_rates_tooltip_inspect: 'Инспектирайте',

  // modals
  util_rates_add_modal_header: 'Добавяне на тарифа',
  util_rates_edit_modal_header: 'Редактиране {{name}}',
  util_rates_delete_modal_header: 'Изтрий {{name}}',
  util_rates_delete_modal_body: 'Това ще изтрие завинаги избраната тарифа за комунални услуги',
  util_rates_confirm: 'Потвърди',
  util_rates_cancel: 'Отказ',
  util_rates_loading: 'Зареждане...',
  util_rates_error: 'Грешка...',
  util_rates_error_name_exists: 'Тарифа с това име вече съществува',

  // errors
  util_rate_fetch_company_error: 'Фирмите не можаха да бъдат заредени',
  util_rate_fetch_util_rates_error: 'Тарифите за комунални услуги не можаха да се заредят',

  //footer
  footer_powered_by: 'Поддържа се от',
  util_rates_name_required: 'Името е задължително',
  util_rates_price_required: 'Цената е задължителна',

  /*
   * |=======|
   * | Icons |
   * |=======|
   */
  icon_type: 'Тип',
  icon_type_device: 'Устройство',
  icon_type_sensor: 'Сензор',

  icon_scope: 'Обхват',
  icon_scope_global: 'Глобален',
  icon_scope_company: 'Компания',
  icon_scope_device: 'Устройство',
  icon_scope_sensor: 'Сензор',

  icon_input_device: 'Устройство',
  icon_input_sensor: 'Сензор',
  icon_input_name: 'Име',
  icon_input_company: 'Компания',

  icon_btn_add_icon: 'Добави икона',
  icon_btn_upload_file: 'Качи файл',
  icon_btn_cancel: 'Отказ',
  icon_btn_save: 'Запази',

  icon_table_name: 'Име',
  icon_table_scope: 'Обхват',
  icon_table_icon: 'Икона',
  icon_table_actions: 'Действия',

  // errors
  icon_error_update_icon: 'Не можах да актуализирам иконата',
  icon_error_unsupported_file_type: 'Невалиден тип файл. Разрешени са само JPEG, PNG и SVG.',
  icon_error_error_occured: 'Възникна грешка',
  icon_error_enter_name: 'Моля, въведете име',
  icon_error_enter_icon: 'Моля, качете икона',
  icon_error_select_company: 'Моля, изберете компания',
  icon_error_select_device: 'Моля, изберете устройство',
  icon_error_select_sensor: 'Моля, изберете сензор',

  /*
   * |=========================|
   * | Customer Billing Report |
   * |=========================|
   */
  customer_billing_report_account_id_table_header: 'Номер на акаунт',
  customer_billing_report_description_table_header: 'Описание',
  customer_billing_report_customer_name_table_header: 'Име на клиента',
  customer_billing_report_street_table_header: 'Улица',
  customer_billing_report_quarter_table_header: 'Квартал',
  customer_billing_report_last_reading_table_header: 'Последно отчитане',
  customer_billing_report_last_reading_date_table_header: 'Дата на последно отчитане',
  customer_billing_report_device_number_table_header: 'Номер на устройство',
  customer_billing_report_last_config_date_table_header: 'Дата на последно конфигуриране',
  customer_billing_report_billing_group_table_header: 'Група за фактуриране',
  customer_billing_report_meter_serial_table_header: 'Сериен номер',
  customer_billing_report_diameter_table_header: 'Диаметър',
  customer_billing_report_meter_brand_table_header: 'Марка',
  customer_billing_report_meter_model_table_header: 'Модел',
  customer_billing_report_default_error: 'Възникна грешка при генериране на отчета',
  customer_billing_report_contract_number_table_header: 'Номер на договор',
  customer_billing_report_device_name_table_header: 'Име на устройство',
  customer_billing_report_sensor_name_table_header: 'Име на сензор',

  //license
  license_license_warning: 'Предупреждение за лиценз',
  license_license_warning_per_reading_over_limit_singular: 'от тип на четене превишава лимита',
  license_license_warning_expire_singular: 'скоро изтича',
  license_license_warning_per_reading_over_limit_plural: 'от тип на четения превишават лимита',
  license_license_warning_expire_plural: 'скоро изтичат',
  license_max_count_error: 'Максималният брой не може да бъде 0',

  license_header: 'Лиценз',
  license_table_company_name: 'Име на компанията',
  license_table_license_type: 'Тип лиценз',
  license_table_max_count: 'Максимален брой',
  license_table_valid_from: 'Валиден от',
  license_table_valid_to: 'Валиден до',
  license_table_first_reading_date: 'Дата на първо отчитане',
  license_table_last_reading_date: 'Дата на последно отчитане',
  license_table_active: 'Активен',
  license_table_valid: 'Валиден',
  license_table_prepaid: 'Предплатен',
  license_table_yes: 'Да',
  license_table_no: 'Не',
  license_table_actions: 'Действия',

  license_warning_access_hold: 'Достъпът до акаунта е преустановен',
  license_warning_access_hold_description:
    'Вашият достъп до платформата е временно преустановен поради неразрешено плащане. Насърчаваме ви да се свържете с нашата поддръжка или да се свържете с вашия назначен представител, за да ви помогне при разрешаване на този проблем.',
  license_warning_no_valid_license: 'Няма валиден лиценз',
  license_warning_no_valid_license_description:
    'Не можахме да намерим валиден лиценз, свързан с този акаунт. Моля, свържете се с вашия определен представител или се свържете с нашата поддръжка за помощ.',
  license_warning_devices_count_limit_reached: 'Максималният брой устройства е достигнат',
  license_warning_devices_count_limit_reached_description:
    'Достигнахте максималният брой устройства от лиценза, които може да свържете към акаунта си. Ако желаете да добавите още, моля, свържете се с вашия определен представител или се свържете с нашата поддръжка за помощ.',
  license_warning_generic_title: 'Няма лиценз',
  license_warning_generic_description: 'Не можете да продължите поради проблем с лиценза.',
  license_info_renew_button: 'Подновете лиценза',
  license_info_deactivate_button: 'Деактивирай лиценза',
  license_info_renew_modal_button: 'Поднови',
  license_info_used_readings: 'Използвани отчети',
  license_info_readings_left: 'Оставащи отчети',
  license_renew_license_button: 'Поднови',
  license_deactivate_license_button: 'Деактивирай',
  license_select_company_warning_message: 'Изберете компания, за да продължите',
  license_add_button: 'Добави лиценз',
  license_add_success_message: 'Лицензът беше създаден успешно',
  license_add_error_message: 'Възникна грешка по време на процеса',
  license_max_devices: 'Максимален брой устройства',
  license_max_readings: 'Максимален брой отчети',
  license_max_sensors: 'Максимален брой сензори',
  license_company: 'Фирма',
  license_deactivate_warning: 'Това ще прекрати достъпа на потребителите до платформата',
  license_activate_warning: 'Това ще възстанови достъпа на потребителите до платформата',
  license_activate_license_button: 'Активирай',
  license_available_licenses: 'Налични лицензи',
  license_add_license: 'Добави лиценз',
  license_status_active: 'Активен',
  license_status_inactive: 'Неактивен',
  license_info_activate_button: 'Активирай лиценз',
  license_info_used_devices: 'Използвани устройства',
  license_info_devices_left: 'Оставащи устройства',
  license_error_page_access_restricted: 'Достъпът е ограничен',
  license_valid_license_existing: 'Вече имате валиден лиценз от този тип!',
  license_conflicting_license_date: 'Има валиден лиценз през същия период',

  license_date_range: 'Период от дати',
  license_validity_period: 'Валиден период',
  provide_period: 'Моля, въведете период',
  license_table_current_count: 'Текущ брой',

  //Password
  change_password: 'Промени паролата',
  current_password: 'Настояща парола',
  new_password: 'Нова парола',
  confirm_new_password: 'Потвърди новата парола',
  customer_info_saved: 'Информацията за клиента е запазена',

  password_min_length: 'Паролата трябва да е дълга поне 10 символа',
  password_uppercase: 'Паролата трябва да съдържа поне една главна буква',
  password_lowercase: 'Паролата трябва да съдържа поне една малка буква',
  password_number: 'Паролата трябва да съдържа поне едно число',
  password_special_char: 'Паролата трябва да съдържа поне един специален символ',
  password_mismatch: 'Паролите не съвпадат',

  /*
   * |=========================|
   * |     Reset Password      |
   * |=========================|
   */
  reset_password_check_email_for_reset_link:
    'Проверете имейла си за връзка за нулиране на паролата',
  reset_password_default_error_message: 'Възникна грешка при опит за нулиране на паролата ви',
  reset_password_change_password_label: 'Промяна на парола',
  reset_password_send_btn: 'Изпрати',

  /*
   * |==============================|
   * |  Sensors and Network Config  |
   * |==============================|
   */

  //headers
  sensors_and_network_config_network_config: 'Мрежова конфигурация',
  sensors_and_network_config_device_details: 'Детайли на устройството',
  sensors_and_network_config_add_sensor: 'Добави сензор',

  //messages
  sensors_and_network_save_success: 'Конфигурацията беше успешно запазена.',
  sensors_and_network_save_error: 'Възникна проблем при запазването на конфигурацията.',
  sensors_and_network_formula_validation_default_error:
    'Валидирането на формулата не беше успешно.',
  sensors_and_network_config_required_field_error: 'Полето е задължително',

  //labels
  sensors_and_network_config_sensor_index: 'Сензор индекс',
  wildPoint_threshold: 'Праг за отклонение',
  //buttons
  sensors_and_network_config_reset_btn: 'Изчисти',
  scale: 'Скала',
  precision: 'Точност',
  initial_value: 'Начална стойност',

  //tooltips
  config_tooltip_select_sensor_icon: 'Изберете икона на сензора',
  config_tooltip_sensor_name: 'Име на сензора',
  config_tooltip_enable_disable_sensor: 'Активиране/Деактивиране на сензора',
  config_tooltip_reset_sensor: 'Нулиране на новите промени за този сензор',
  config_tooltip_reset_all_fields: 'Нулиране на всички полета до последните запазени стойности',
  config_tooltip_delete_sensor: 'Изтриване на сензора',
  config_tooltip_sensor_description: 'Описание на сензора',
  config_tooltip_sensor_model: 'Модел на сензора',
  config_tooltip_sensor_serial_number: 'Сериен номер на сензора',
  config_tooltip_sensor_manufacturer: 'Производител на сензора',
  config_tooltip_sensor_useInSensorsAggregation:
    'Посочва дали данните трябва да се използват от автоматичния агрегатор на Thingslog.',
  config_tooltip_sensor_visibility:
    'Определя дали сензорът трябва да бъде видим в портала на Thingslog.',
  config_tooltip_sensor_scale:
    'Точност след десетичната запетая за всички изчисления по формулата.',
  config_tooltip_port_formula: 'Използва се за преобразуване на сурови ADC стойности в mA или V',
  config_tooltip_sensor_formula:
    'Използва се за преобразуване на X в mA или V в измерената стойност, например ниво, налягане, температура и други.',
  config_tooltip_sensor_pulseRate: 'Колко единици представлява един импулс',
  config_tooltip_sensor_offset:
    'Числова стойност (+ или -), която ще се добавя към изпратените от устройството показания.',
  config_tooltip_sensor_flow_units: 'Единици на дебита - например м3/ч или кВт/ч',
  config_tooltip_sensor_flow_time_units:
    'Периодът от време, използван за изчисляване на единицата - например секунди',
  config_tooltip_sensor_flow_conversion_coefficient:
    'Колко времеви единици са необходими за постигане на единицата от суровите показания',

  config_tooltip_sensor_diameter: 'Диаметър на тръбата',
  config_tooltip_sensor_q3: 'Q3 коефициент на водомера',
  config_tooltip_sensor_r: 'Точност на водомера',
  config_tooltip_wildPoint_threshold:
    'Задава максимално допустимата разлика между последователни показания на сензора. Ако се надвиши, пакетът се счита за дефектен и се изтрива.',

  /*
   * |==============================|
   * |     Documentation Page       |
   * |==============================|
   */

  documentation_title: 'Документация',
  documentation_platform: 'Документация на платформата',
  documentation_data_logger: 'Документация на логери',
  documentation_communication_protocol: 'Документация за комуникационния протокол',
  documentation_sign_in_main_menu: 'Регистрация/Вход и Главно меню',
  documentation_account_management: 'Управление на акаунти в ThingsLog',
  documentation_user_management: 'Управление на потребители в ThingsLog',
  documentation_data_loggers_configuration: 'Конфигурация на устройства в ThingsLog',
  documentation_alarms_value_range_events:
    'Конфигуриране и преглед на аларми и събития на стойности в ThingsLog',
  documentation_modbus_slave_devices:
    'Конфигуриране на параметри за порт и сензор за Modbus устройства',
  documentation_tasmota_devices: 'Настройка на Tasmota устройства в ThingsLog платформата',
  documentation_modbus_setup: 'Настройка на Modbus устройства за работа с контролерите ThingsLog',
  documentation_licenses: 'Лицензи',
  documentation_old_user_manual: 'Старо ръководство за потребителя',
  documentation_data_logger_manual: 'Ръководство за потребителя за ThingsLog устройства',
  documentation_data_logger_command_guide: 'Ръководство за команди на ThingsLog устройства',
  documentation_lora_protocol: 'Отворен LoRa протокол за данни',
  documentation_mqtt_protocol: 'MQTT протокол за отворени данни',
  documentation_getting_started_training_guide: 'Ръководство за обучение за първи стъпки',
  documentation_view_pdf: 'Вижте PDF',

  /*
   * |=====================|
   * | Device Nodes Page  |
   * |=====================|
   */

  device_nodes_table_no_links_found: 'Не са намерени връзки между възли на устройства',
  device_nodes_table_error: 'Неуспешно извличане на връзки между възли на устройства',
  device_nodes_table_source_device_number: 'Номер на изходно устройство',
  device_nodes_table_source_sensor_index: 'Индекс на изходен сензор',
  device_nodes_table_target_device_number: 'Номер на целево устройство',
  device_nodes_table_target_sensor_index: 'Индекс на целеви сензор',
  device_nodes_table_is_active: 'Активно',

  device_nodes_create_link: 'Създаване на връзка',
  device_nodes_source_device_required: 'Изходното устройство е задължително',
  device_nodes_source_device: 'Изходно устройство',
  device_nodes_sensor_index_required: 'Индексът на сензора е задължителен',
  device_nodes_sensor_index_min: 'Индексът на сензора трябва да бъде поне 0',
  device_nodes_source_sensor_index: 'Индекс на изходен сензор',
  device_nodes_target_device_required: 'Целевото устройство е задължително',
  device_nodes_target_device: 'Целево устройство',
  device_nodes_target_sensor_index: 'Индекс на целеви сензор',
  device_nodes_is_active: 'Активно',
  device_nodes_create_link_button: 'Създаване на връзка',
  device_nodes_same_device_error: 'Изходното и целевото устройство не могат да бъдат същите',

  device_nodes_delete_links: 'Изтриване на връзки',
  device_nodes_device_required: 'Устройството е задължително',
  device_nodes_device: 'Устройство',
  device_nodes_role_required: 'Ролята е задължителна',
  device_nodes_role: 'Роля',
  device_nodes_role_source: 'Източник',
  device_nodes_role_target: 'Цел',
  device_nodes_sensor_index: 'Сензор (Незадължително)',
  device_nodes_no_sensors_available: 'Няма налични сензори',
  device_nodes_sensor_optional: 'Оставете празно, за да изтриете всички връзки на устройството',
  device_nodes_delete_warning: 'Предупреждение: Това действие не може да бъде отменено!',
  device_nodes_delete_button: 'Изтриване на връзки',

  /*
   * |======================|
   * | Scheduled Reports   |
   * |======================|
   */
  // Generated Reports Page
  generated_reports_header: 'Генерирани отчети',
  generated_reports_select_company_message:
    'Моля, изберете компания, за да видите генерираните отчети',
  generated_reports_default_error: 'Възникна грешка при извличане на генерираните отчети',
  generated_reports_config_button: 'Конфигурация',
  generated_reports_config_name_header: 'Име на конфигурацията',
  generated_reports_date_header: 'Дата на отчета',
  generated_reports_type_header: 'Тип отчет',
  generated_reports_file_name_header: 'Име на файла',
  generated_reports_parameters_header: 'Параметри',

  // Report Configs Page
  report_configs_header: 'Конфигурации на отчети',
  report_configs_select_company_message:
    'Моля, изберете компания за управление на конфигурациите на отчети',
  report_configs_default_error: 'Възникна грешка при извличане на конфигурациите на отчети',
  report_configs_name_header: 'Име на отчета',
  report_configs_type_header: 'Тип отчет',
  report_configs_occurrence_header: 'Честота',
  report_configs_device_groups_header: 'Групи устройства',
  report_configs_email_list_header: 'Списък с имейли',
  report_configs_start_date_header: 'Начална дата',
  report_configs_end_date_header: 'Крайна дата',
  report_configs_next_execution_header: 'Следващо изпълнение',
  report_configs_actions_header: 'Действия',
  report_configs_delete_action: 'Изтрий',
  report_configs_delete_success: 'Конфигурацията на отчета беше успешно изтрита',
  report_configs_delete_error: 'Възникна грешка при изтриването на конфигурацията на отчета',
  report_configs_create_button: 'Създай конфигурация на отчет',
  report_configs_edit_action: 'Редактирай',

  // Report Config Form
  report_config_form_report_name: 'Име на отчета',
  report_config_form_report_type: 'Тип отчет',
  report_config_form_occurrence: 'Честота',
  report_config_form_device_groups: 'Групи устройства',
  report_config_form_email_list: 'Списък с имейли',
  report_config_form_email_list_hint: 'Разделете няколко имейла със запетаи',
  report_config_form_start_date: 'Начална дата',
  report_config_form_end_date: 'Крайна дата',
  report_config_form_calculate: 'Изчисли',
  report_config_form_calc_min: 'Минимум',
  report_config_form_calc_max: 'Максимум',
  report_config_form_calc_average: 'Средна стойност',
  report_config_form_cancel: 'Отказ',
  report_config_form_create: 'Създай',
  report_config_form_update: 'Актуализирай',
  report_config_form_field_required: 'Това поле е задължително',
  report_config_form_device_groups_required: 'Трябва да бъде избрана поне една група устройства',
  report_config_form_license_settings: 'Настройки на отчета за лиценза',
  report_config_form_license_is_active: 'Активен',
  report_config_form_license_is_valid: 'Валиден',

  // Report Types
  report_type_consumption: 'Отчет за потребление',
  report_type_consumption_export: 'Експорт на потребление',
  report_type_customer_billing: 'Отчет за фактуриране на клиенти',
  report_type_alarm: 'Отчет за аларми',
  report_type_transmission: 'Отчет за предаване',
  report_type_license: 'Отчет за лиценза',

  // Report Occurrence
  report_occurrence_daily: 'Дневно',
  report_occurrence_weekly: 'Седмично',
  report_occurrence_monthly: 'Месечно',

  // Create/Edit Pages
  report_config_create_header: 'Създаване на конфигурация на отчет',
  report_config_create_success: 'Конфигурацията на отчета беше успешно създадена',
  report_config_create_error: 'Възникна грешка при създаването на конфигурацията на отчета',
  report_config_edit_header: 'Редактиране на конфигурация на отчет',
  report_config_update_success: 'Конфигурацията на отчета беше успешно актуализирана',
  report_config_update_error: 'Възникна грешка при актуализирането на конфигурацията на отчета',
  report_config_fetch_error: 'Възникна грешка при извличането на конфигурацията на отчета',
  report_config_not_found: 'Конфигурацията на отчета не е намерена',
  report_config_form_email_list_required: 'Необходим е поне един имейл адрес',
  report_config_form_email_invalid: 'Невалиден имейл адрес: {{email}}',
  report_config_form_email_no_spaces: 'Имейл адресите не могат да съдържат интервали',
  report_configs_delete_confirm_title: 'Изтриване на конфигурация на отчет',
  report_configs_delete_confirm_message:
    'Сигурни ли сте, че искате да изтриете конфигурацията на отчета "{{reportName}}"? Това действие не може да бъде отменено.',
  report_configs_delete_cancel: 'Отказ',
  report_configs_delete_confirm: 'Изтрий',
  report_configs_deleting: 'Изтриване...',

  /*
   * |====================|
   * | Sensors Data Page  |
   * |====================|
   */

  // Page
  sensors_data_no_selection_made: 'Няма направен избор',
  sensors_data_no_selection_subtitle:
    'Използвайте контролите по-горе, за да изберете устройство или група устройства, за да видите техните показания на сензорите.',

  // Device Readings Selector Generic
  sensors_data_select_device_group: 'Изберете група устройства',
  sensors_data_search_device_group: 'Търсене по име на група устройства',
  sensors_data_add: 'Добави',
  sensors_data_select_device: 'Изберете устройство',
  sensors_data_search_device: 'Търсене по име или номер на устройство',
  sensors_data_select_sensor: 'Изберете сензор',
  sensors_data_search_sensor: 'Търсене по име или индекс на сензор',
  sensors_data_select_devices: 'Изберете устройства',
  sensors_data_select_sensor_type: 'Изберете тип сензор',
  sensors_data_search_sensor_type: 'Търсене по тип сензор',
  sensors_data_submit: 'Изпрати',

  // Device Readings Selector Specific
  sensors_data_select_sensors: 'Изберете сензори',

  // Selected Items Display
  sensors_data_group: 'Група',

  // Readings Data Display
  sensors_data_click_to_view_readings: 'Кликнете, за да видите показанията',
  sensors_data_view_sensor_data_subtitle: 'Преглед на данни от сензори и информация за експорт',
  sensors_data_raw: 'Сурови',
  sensors_data_export: 'Експорт',
  sensors_data_format: 'Формат',
  sensors_data_csv: 'CSV',
  sensors_data_excel: 'EXCEL',
  sensors_data_device_number: 'Номер на устройство',
  sensors_data_device_name: 'Име на устройство',
  sensors_data_sensor_name: 'Име на сензор',
  sensors_data_date: 'Дата',
  sensors_data_value: 'Стойност',
  sensors_data_no_data_available: 'Няма налични данни',
  sensors_data_sensor_index: 'Индекс на сензор',
  sensors_data_counters: 'Броячи',
  sensors_data_previous: 'Предишен',
  sensors_data_delta: 'Делта',
  sensors_data_collapse: 'Скрий',

  // Sensors Data Chart
  sensors_data_chart_no_data_available: 'Няма налични данни',
  sensors_data_chart_no_numeric_data_subtitle:
    'Заявката беше успешна, но не бяха върнати числени данни за избрания период.',
  sensors_data_chart_min: 'мин -',
  sensors_data_chart_max: 'макс -',

  // Sensors Data Map
  sensors_data_map_loading: 'Зареждане на карта...',

  //Warranty Data
  manufacturing_date: 'Дата на производство',
  warranty_type: 'Тип гаранция',
  warranty_extended_support: 'Удължена поддръжка',
  warranty_basic: 'Основна',
  warranty_status: 'Статус на гаранцията',
  warranty_status_UNKNOWN: 'Неизвестен',
  warranty_status_IN_WARRANTY: 'В гаранция',
  warranty_status_EXPIRED: 'Изтекла',
  warranty_period_months: 'Гаранционен период',
  install_date: 'Дата на инсталиране',
  install_warranty_exp_date: 'Дата на изтичане на инсталационната гаранция',
  install_warranty_period_months: 'Гаранционен срок след инсталацията',

  // Mobile Query Preview
  sensors_data_mobile_groups: 'Група(и)',
  sensors_data_mobile_sensors: 'Сензор(и)',
  sensors_data_mobile_types: 'Тип(ове)',
  sensors_data_mobile_no_filters_selected: 'Няма избрани филтри',

  // Quick Sensor Selector
  sensors_data_quick_select_sensor: 'Изберете сензор, за да видите показанията',

  // Mobile Fab Button
  sensors_data_view_table: 'виж таблица',
  sensors_data_view_chart: 'виж графика',
  // Fallbacks added to keep locale keys aligned with English.
  device_counter_statistics_must_have_initialized_params:
    'Parameters Q3, R, and Diameter are required on pulse input connected to a water meter sensor.',
  transmissions_page_yes: 'Yes',
  transmissions_page_no: 'No',
  device_groups_add_sensor_device: 'Add sensor and device to group',
  value_range_name_incorrect_time: 'Incorrect time format',
  value_range_error_occurred: 'An error occurred',
  // Dashboard localization additions
  cancel: 'Отказ',
  edit: 'Редакция',
  save_btn: 'Запази',
  resize: 'Преоразмеряване',
  value: 'Стойност',
  time: 'Време',
  dashboards_title: 'Табла',
  dashboard_add_dashboard: 'Добави Табло',
  dashboard_edit_dashboard: 'Редактирай Табло',
  dashboard_delete_dashboard: 'Изтрий Табло',
  dashboard_search_dashboards: 'Търсене табла',
  dashboard_search_by_name: 'търсене по име',
  dashboard_create_dashboard: 'Създай Табло',
  dashboard_save_dashboard: 'Запази Табло',
  dashboard_name: 'Табло Име',
  dashboard_name_required: 'Табло Име е задължително',
  dashboard_name_max_length: 'Табло Име трябва да е под 100 знака',
  dashboard_time_period: 'Период',
  dashboard_dashboard_time_period: 'Период на таблото',
  dashboard_dashboard_time_period_description: 'Периодът по подразбиране за данните на таблото.',
  dashboard_save_period: 'Запази Период',
  dashboard_edit_dashboard_period: 'Редактирай Период на таблото',
  dashboard_period: 'Период на таблото',
  dashboard_predefined_period: 'Предварително зададен период',
  dashboard_period_dashboard: 'Табло',
  dashboard_period_predefined: 'Предварително',
  dashboard_period_preset: 'Шаблон',
  dashboard_period_custom: 'По избор',
  dashboard_timespan_today: 'Днес',
  dashboard_timespan_yesterday: 'Вчера',
  dashboard_timespan_this_week: 'Тази седмица',
  dashboard_timespan_this_month: 'Този месец',
  dashboard_timespan_this_year: 'Тази година',
  dashboard_timespan_past_1d: 'Последният 1 ден',
  dashboard_timespan_past_1w: 'Последната 1 седмица',
  dashboard_timespan_past_1m: 'Последният 1 месец',
  dashboard_timespan_past_1y: 'Последната 1 година',
  dashboard_start_date_required: 'Стартирай date is е задължително',
  dashboard_end_date_required: 'Крайната дата е задължителна',
  dashboard_end_date_before_start_error: 'край дата преди начало грешка',
  dashboard_predefined_period_required: 'предварително период задължително',
  dashboard_default_dashboard_name: 'По подразбиране Табло',
  dashboard_loading: 'Зареждане...',
  dashboard_redirecting: 'Пренасочване...',
  dashboards_load_error: 'зареждане грешка',
  dashboard_load_error: 'зареждане грешка',
  dashboard_loading_data_sources: 'зареждане данни източници',
  dashboard_data_sources_load_error: 'данни източници зареждане грешка',
  dashboard_empty_title: 'Създайте първия си уиджет',
  dashboard_empty_description:
    'Добавете уиджет, за да започнете да визуализирате данни в това табло.',
  dashboard_confirm_changes_title: 'Потвърждаване на промените',
  dashboard_save_layout_confirmation:
    'Сигурни ли сте, че искате да запазите промените? Всички промени ще бъдат приложени към таблото.',
  dashboard_save_layout: 'Запази оформление',
  dashboard_edit_layout: 'Редактирай оформление',
  dashboard_add_widget: 'Добави уиджет',
  dashboard_widgets: 'Уиджети',
  dashboard_widget: 'Уиджет',
  dashboard_untitled_widget: 'Неозаглавен уиджет',
  dashboard_no_widgets_yet: 'не уиджети yet',
  dashboard_create_widget: 'Създай уиджет',
  dashboard_save_widget: 'Запази уиджет',
  dashboard_edit_widget: 'Редактирай уиджет',
  dashboard_delete_widget: 'Изтрий уиджет',
  dashboard_yes_delete: 'Да, изтрий',
  dashboard_widget_no_longer_exists: 'Уиджетът вече не съществува.',
  dashboard_widget_delete_confirmation_prefix: 'Това ще изтрие окончателно уиджета',
  dashboard_widget_delete_confirmation_suffix: 'Това действие не може да бъде отменено.',
  dashboards_empty_no_dashboards_title: 'Няма табла',
  dashboards_empty_no_results_title: 'Няма резултати',
  dashboards_empty_no_dashboards_description: 'Все още няма създадени табла.',
  dashboards_empty_no_results_description: 'Няма табла, които съвпадат с търсенето.',
  dashboard_add_default_dashboard: 'Добави По подразбиране Табло',
  dashboard_this_dashboard: 'този табло',
  dashboard_delete_confirmation: 'Сигурни ли сте, че искате да изтриете {{name}}?',
  dashboard_no_longer_exists: 'Табло Уиджетът вече не съществува.',
  dashboard_edit_named_dashboard: 'Редактирай {{name}}',
  dashboard_fallback_dashboard: 'Табло',
  dashboard_edit_current_dashboard: 'редактирай текущ табло',
  dashboard_all_dashboards: 'All Табла',
  dashboard_start_selector_guide: 'начало селектор ръководство',
  dashboard_close_dashboards: 'Затвори табла',
  dashboard_open_dashboards: 'Отвори табла',
  dashboard_edit_period: 'Редактирай табло период',
  dashboard_variables: 'Променливи',
  dashboard_hide_app_header: 'Скрий заглавката на приложението',
  dashboard_show_app_header: 'Покажи заглавката на приложението',
  dashboard_start_tour: 'начало обиколка',
  dashboard_remove_from_favorites: 'Премахни от любими',
  dashboard_add_to_favorites: 'Добави към любими',
  dashboard_default_dashboard: 'По подразбиране табло',
  dashboard_set_as_default: 'Задай по подразбиране',
  dashboard_favorite_tooltip: 'Маркирай като любимо',
  dashboard_default_tooltip: 'Табло по подразбиране',
  dashboard_widget_type: 'Тип уиджет',
  dashboard_widget_type_required: 'Типът уиджет е задължителен',
  dashboard_widget_type_line_chart: 'Линейна графика',
  dashboard_widget_type_bar_chart: 'Стълбовидна графика',
  dashboard_widget_type_pie_chart: 'Кръгова графика',
  dashboard_widget_type_area_chart: 'Площна графика',
  dashboard_widget_type_gauge: 'Индикатор',
  dashboard_widget_type_value: 'Стойност',
  dashboard_widget_type_table: 'Таблица',
  dashboard_widget_title: 'Заглавие',
  dashboard_widget_title_required: 'Заглавието е задължително',
  dashboard_widget_title_max_length: 'Заглавието трябва да е под 100 знака',
  dashboard_data_source: 'Източник на данни',
  dashboard_data_source_required: 'Източникът на данни е задължителен',
  dashboard_query_settings: 'Настройки на заявката',
  dashboard_no_data_sources_available: 'Няма налични източници на данни',
  dashboard_no_data_sources_description:
    'Конфигурирайте източник на данни за таблото, преди да създавате или редактирате уиджети.',
  dashboard_select_data_source_to_configure_query:
    'Изберете източник на данни, за да настроите заявката.',
  dashboard_query_type_not_supported: 'Този тип заявка все още не се поддържа.',
  dashboard_no_widget_timeframe: 'Няма период за уиджета',
  dashboard_no_widget_timeframe_description: 'Този уиджет наследява периода от таблото.',
  dashboard_widget_time_period: 'Период на уиджета',
  dashboard_widget_time_period_description:
    'Задайте отделен период за този уиджет или използвайте периода на таблото.',
  dashboard_edit_widget_timeframe: 'Редактирай периода на уиджета',
  dashboard_edit_widget_timeframe_inherited:
    'Редактирай периода на уиджета. В момента се наследява от таблото.',
  dashboard_widget_settings: 'Настройки на уиджета',
  dashboard_shift_scroll_to_zoom: 'Shift + скрол за мащабиране',
  dashboard_zoom_in: 'Приближаване',
  dashboard_zoom_out: 'Отдалечаване',
  dashboard_zoom_reset: 'Нулиране на мащаба',
  dashboard_inherited_timeframe_label: 'Табло: {{label}}',
  dashboard_edit_timeframe: 'Редактирай период',
  dashboard_edit_widget_period: 'Редактирай периода на уиджета',
  dashboard_edit_named_widget: 'Редактирай {{name}}',
  dashboard_edit_named_widget_period: 'Редактирай {{name}} Период',
  dashboard_data_type: 'Тип данни',
  dashboard_data_type_description:
    'Изберете дали заявката да предпочита показания или изчислен поток.',
  dashboard_readings: 'Показания',
  dashboard_query_time_period_description: 'Изберете времевия диапазон за данните на заявката.',
  dashboard_battery_level: 'Ниво на батерията',
  dashboard_battery_level_description: 'Ограничава уиджета до диапазон на батерията.',
  dashboard_signal_level: 'Ниво на сигнала',
  dashboard_signal_level_description: 'Ограничава уиджета до диапазон на сигнала.',
  dashboard_signal_values: 'Стойности на сигнала',
  dashboard_signal_values_description: 'Изберете кои стойности на сигнала да се показват.',
  dashboard_signal_value_required: 'Изберете поне една стойност на сигнала',
  dashboard_transmission_values: 'Стойности на предаванията',
  dashboard_transmission_values_description:
    'Изберете кои стойности на предаванията да се показват.',
  dashboard_transmission_value_required: 'Изберете поне една стойност на предаване',
  dashboard_days: 'Дни',
  dashboard_transmissions: 'Предавания',
  dashboard_count: 'Брой',
  dashboard_unit_days: 'дни',
  dashboard_transmitting: 'Предава',
  devices: 'Устройства',
  dashboard_device_sensor: 'Сензор на устройство',
  dashboard_device_sensor_description: 'Изберете устройство и сензор за този уиджет.',
  dashboard_device_required: 'Устройството е задължително',
  dashboard_sensor_required: 'Сензорът е задължителен',
  dashboard_devices_optional_description:
    'Pick устройства to include. Leave empty to include all устройства.',
  dashboard_no_devices_selected_uses_all:
    'Няма избрани устройства. Уиджетът ще използва всички устройства.',
  dashboard_device_groups: 'Групи устройства',
  dashboard_device_groups_description: 'Изберете една или повече групи устройства за заявката.',
  dashboard_select_one_device_group_required: 'Изберете поне една група устройства',
  dashboard_device_groups_optional_description:
    'Незадължителни групови източници за смесената заявка.',
  dashboard_no_groups_selected: 'Няма избрани групи.',
  dashboard_device_sensors: 'Сензори на устройства',
  dashboard_device_sensors_description:
    'Добавете двойки устройство и сензор, които да бъдат прочетени.',
  dashboard_device_sensors_optional_description:
    'Незадължителни двойки от номера на устройства и индекси на сензори.',
  dashboard_add_device_sensor_required: 'Добавете поне един сензор на устройство',
  dashboard_add_device_sensor: 'Добави Сензор на устройство',
  dashboard_remove_device_sensor: 'Remove устройство сензор',
  dashboard_device_sensor_types: 'Типове сензори на устройства',
  dashboard_device_sensor_types_description:
    'Изберете устройства и типа сензор, който да бъде прочетен от тях.',
  dashboard_device_sensor_types_optional_description:
    'Незадължителни групи устройства, съпоставени по тип сензор.',
  dashboard_add_device_sensor_type_required: 'Добавете поне един тип сензор на устройство',
  dashboard_sensor_type: 'Сензор Тип',
  dashboard_add_sensor_type: 'Добави Сензор Тип',
  dashboard_remove_sensor_type: 'Премахни тип сензор',
  dashboard_variable: 'променлива',
  dashboard_sensor_index_option: 'Сензор {{index}}',
  dashboard_visualization: 'Визуализация',
  dashboard_visualization_description: 'Опции за показване и стил на графиката',
  dashboard_visualization_show_grid: 'Показвай мрежа',
  dashboard_visualization_show_legend: 'Показвай легенда',
  dashboard_visualization_render_legend_aside: 'Легенда отстрани',
  dashboard_visualization_show_legend_aside: 'Легенда отстрани',
  dashboard_visualization_show_x_axis_labels: 'Показвай етикети на оста X',
  dashboard_visualization_show_y_axis_labels: 'Показвай етикети на оста Y',
  dashboard_visualization_line_thickness: 'Дебелина на линията',
  dashboard_visualization_interpolation: 'Интерполация',
  dashboard_visualization_show_points: 'Показвай точки',
  dashboard_visualization_points_hidden_helper:
    'Точките автоматично се скриват, когато времевата серия има над {{count}} точки.',
  dashboard_visualization_stack_series: 'Натрупвай серии',
  dashboard_visualization_fill_opacity: 'Непрозрачност на запълване',
  dashboard_visualization_orientation: 'Ориентация',
  dashboard_visualization_grouping: 'Групиране',
  dashboard_visualization_bar_thickness: 'Дебелина на стълбовете',
  dashboard_visualization_shape: 'Форма',
  dashboard_visualization_gauge_type: 'Тип индикатор',
  dashboard_visualization_bar_orientation: 'Ориентация на стълб',
  dashboard_visualization_minimum: 'Минимум',
  dashboard_visualization_maximum: 'Максимум',
  dashboard_visualization_gauge_color: 'Цвят на индикатора',
  dashboard_visualization_value_color: 'Основен цвят',
  dashboard_visualization_value_prefix: 'Префикс',
  dashboard_visualization_value_suffix: 'Суфикс',
  dashboard_visualization_value_stacked: 'Префикс отгоре, суфикс отдолу',
  dashboard_visualization_value_compact: 'Компактни числа',
  dashboard_visualization_value_target: 'Цел',
  dashboard_visualization_value_show_target_percentage: 'Покажи % от целта',
  dashboard_visualization_value_text_color: 'Персонализиран цвят на текста',
  dashboard_visualization_colors: 'Цветове',
  dashboard_value_percent_of_target: '{{percent}}% от целта',
  dashboard_value_percent_above_target: '{{percent}}% над целта',
  dashboard_visualization_show_value: 'Показвай стойност',
  dashboard_visualization_show_min_max: 'Показвай мин./макс.',
  dashboard_visualization_show_thresholds: 'Показвай прагове',
  dashboard_visualization_paginate_rows: 'Страницирай редове',
  dashboard_visualization_thresholds: 'Прагове',
  dashboard_visualization_add_threshold: 'Добави праг',
  dashboard_visualization_level: 'Ниво',
  dashboard_visualization_label: 'Етикет',
  dashboard_visualization_color: 'Цвят',
  dashboard_visualization_remove_threshold: 'Премахни праг',
  dashboard_visualization_threshold_warning: 'Предупреждение',
  dashboard_visualization_threshold_critical: 'Критично',
  dashboard_visualization_threshold_named: 'Праг {{index}}',
  dashboard_visualization_option_fine: 'Фина',
  dashboard_visualization_option_standard: 'Стандартно',
  dashboard_visualization_option_bold: 'Удебелена',
  dashboard_visualization_option_straight: 'Права',
  dashboard_visualization_option_smooth: 'Гладка',
  dashboard_visualization_option_stepped: 'Стъпаловидна',
  dashboard_visualization_option_subtle: 'Лека',
  dashboard_visualization_option_balanced: 'Балансирана',
  dashboard_visualization_option_solid: 'Плътна',
  dashboard_visualization_option_vertical: 'Вертикално',
  dashboard_visualization_option_horizontal: 'Хоризонтално',
  dashboard_visualization_option_grouped: 'Групирани',
  dashboard_visualization_option_stacked: 'Натрупани',
  dashboard_visualization_option_slim: 'Тънка',
  dashboard_visualization_option_regular: 'Обикновено',
  dashboard_visualization_option_wide: 'Широка',
  dashboard_visualization_option_pie: 'Кръгова',
  dashboard_visualization_option_donut: 'Поничка',
  dashboard_visualization_option_dial: 'Циферблат',
  dashboard_visualization_option_bar: 'Стълб',
  dashboard_add_variable: 'Добави Променлива',
  dashboard_edit_variable: 'Редактирай Променлива',
  dashboard_delete_variable: 'Изтрий Променлива',
  dashboard_variable_no_longer_exists: 'Променливата вече не съществува.',
  dashboard_edit_named_variable: 'Редактирай {{name}}',
  dashboard_variable_edit_mode_description:
    'Локалните промени засягат само това табло. Отдалечените промени обновяват запазената променлива.',
  dashboard_local: 'Локално',
  dashboard_remote: 'Отдалечено',
  dashboard_variable_name: 'Име',
  dashboard_variable_name_required: 'Име is е задължително',
  dashboard_variable_name_pattern: 'променлива име pattern',
  dashboard_variable_label: 'Етикет',
  dashboard_variable_label_required: 'Етикет is е задължително',
  dashboard_variable_single: 'Единична',
  dashboard_variable_multi: 'Множествена',
  dashboard_variable_value: 'Стойност',
  dashboard_variable_values: 'Стойности',
  dashboard_variable_value_required: 'Стойност is е задължително',
  dashboard_variable_at_least_one_value_required: 'Поне една стойност е задължителна',
  dashboard_variable_values_helper: 'Разделяйте няколко стойности със запетаи.',
  dashboard_apply_locally: 'Приложи locally',
  dashboard_no_variables_yet: 'Няма променливи',
  dashboard_no_variables_description: 'Все още няма променливи за това табло.',
  dashboard_variable_value_count: '{{count}} стойност',
  dashboard_empty_value: 'Празно',
  dashboard_open_variable_actions: 'Отвори {{name}} actions',
  dashboard_variable_delete_confirmation_prefix: 'Това ще изтрие окончателно променливата',
  dashboard_no_data_available: 'Няма налични данни',
  dashboard_widget_failed_to_load_data: 'Данните не се заредиха',
  dashboard_click_to_retry: 'Щракнете за повторен опит',
  dashboard_chart_sampled_points_tooltip:
    'Показва се извадка от реални точки. Увеличете, за да видите пропуснатите точки.',
  dashboard_chart_all_points_tooltip: 'Показват се всички точки от текущия изглед.',
  dashboard_widget_no_areas: 'Този уиджет няма области за показване.',
  dashboard_widget_no_bars: 'Този уиджет няма стълбове за показване.',
  dashboard_widget_no_points: 'Този уиджет няма точки за чертане.',
  dashboard_widget_no_slices: 'Този уиджет няма сектори за показване.',
  dashboard_widget_too_many_slices: 'Твърде много сектори за показване',
  dashboard_widget_too_many_slices_description:
    'Този уиджет има {{slices}} сектора. Изчертаването на всички ще забави зареждането и работата с таблото, а диаграмата ще е трудна за разчитане.',
  dashboard_widget_render_anyway: 'Покажи въпреки това',
  dashboard_table_settings_missing: 'Настройките на таблицата липсват.',
  dashboard_widget_no_rows: 'Този уиджет няма редове за показване.',
  dashboard_gauge_settings_missing: 'Настройките на индикатора липсват.',
  dashboard_value_settings_missing: 'Настройките на стойността липсват.',
  dashboard_widget_no_value: 'Този уиджет няма стойност за показване.',
  dashboard_widget_no_numeric_value: 'Този уиджет няма числова стойност за показване.',
  dashboard_timestamp: 'Време',
  dashboard_alarm_type: 'Тип аларма',
  dashboard_alarm_count: 'Брой аларми',
  dashboard_level: 'Ниво',
  dashboard_series_index: 'Серия {{index}}',
  dashboard_gauge_normal: 'Нормално',
  dashboard_gauge_threshold: 'Праг',
  dashboard_start_named_guide: 'Стартирай {{title}} ръководство',
  dashboard_expand_named: 'Разшири {{title}}',
  dashboard_expand_named_widget: 'Разшири уиджета {{title}}',
  dashboard_close_named: 'Затвори {{title}}',
  dashboard_close_named_widget: 'Затвори {{title}} уиджет',
  dashboard_close_expanded_named_widget: 'Затвори разширения уиджет {{title}}',
  dashboard_tour_header_dashboards: 'Помощ: заглавна лента табла.',
  dashboard_tour_header_settings: 'Помощ: заглавна лента настройки.',
  dashboard_tour_header_title: 'Помощ: заглавна лента заглавие.',
  dashboard_tour_header_period: 'Помощ: заглавна лента период.',
  dashboard_tour_header_layout: 'Помощ: заглавна лента оформление.',
  dashboard_tour_header_add_widget: 'Помощ: заглавна лента добавяне уиджет.',
  dashboard_tour_header_variables: 'Помощ: заглавна лента променливи.',
  dashboard_tour_header_toggle_app_header:
    'Помощ: заглавна лента превключване приложение заглавна лента.',
  dashboard_tour_dashboard_canvas: 'Помощ: табло работна област.',
  dashboard_tour_selection_search: 'Помощ: избор търсене.',
  dashboard_tour_selection_add: 'Помощ: избор добавяне.',
  dashboard_tour_selection_list: 'Помощ: избор списък.',
  dashboard_tour_selection_favorite: 'Помощ: избор любимо.',
  dashboard_tour_selection_default: 'Помощ: избор по подразбиране.',
  dashboard_tour_selection_all: 'Помощ: избор всички.',
  dashboard_tour_widget_title: 'Помощ: уиджет заглавие.',
  dashboard_tour_widget_type: 'Помощ: уиджет тип.',
  dashboard_tour_widget_data_source: 'Помощ: уиджет данни източник.',
  dashboard_tour_query_single_device: 'Помощ: заявка единичен устройство.',
  dashboard_tour_query_single_sensor: 'Помощ: заявка единичен сензор.',
  dashboard_tour_query_specific_devices: 'Помощ: заявка конкретни устройства.',
  dashboard_tour_query_battery_range: 'Помощ: заявка батерия диапазон.',
  dashboard_tour_query_device_groups: 'Помощ: заявка устройство групи.',
  dashboard_tour_query_device_sensor_list: 'Помощ: заявка устройство сензор списък.',
  dashboard_tour_query_device_sensor_device: 'Помощ: заявка устройство сензор устройство.',
  dashboard_tour_query_device_sensor_sensor: 'Помощ: заявка устройство сензор сензор.',
  dashboard_tour_query_device_sensor_add: 'Помощ: заявка устройство сензор добавяне.',
  dashboard_tour_query_device_type_list: 'Помощ: заявка устройство тип списък.',
  dashboard_tour_query_device_type_devices: 'Помощ: заявка устройство тип устройства.',
  dashboard_tour_query_device_type_sensor_type: 'Помощ: заявка устройство тип сензор тип.',
  dashboard_tour_query_device_type_add: 'Помощ: заявка устройство тип добавяне.',
  dashboard_tour_query_prefer_flow: 'Помощ: заявка предпочитане поток.',
  dashboard_tour_query_timespan_mode: 'Помощ: заявка времеви период режим.',
  dashboard_tour_query_timespan_preset: 'Помощ: заявка времеви период шаблон.',
  dashboard_tour_query_timespan_custom: 'Помощ: заявка времеви период по избор.',
  dashboard_tour_widget_actions: 'Помощ: уиджет действия.',
  dashboard_tour_widget_delete: 'Помощ: уиджет изтриване.',
  dashboard_tour_dashboard_name: 'Помощ: табло име.',
  dashboard_tour_dashboard_period: 'Помощ: табло период.',
  dashboard_tour_dashboard_timespan_mode: 'Помощ: табло времеви период режим.',
  dashboard_tour_dashboard_timespan_preset: 'Помощ: табло времеви период шаблон.',
  dashboard_tour_dashboard_timespan_custom: 'Помощ: табло времеви период по избор.',
  dashboard_tour_variable_add: 'Помощ: променлива добавяне.',
  dashboard_tour_variable_row: 'Помощ: променлива ред.',
  dashboard_tour_variable_actions: 'Помощ: променлива действия.',
  dashboard_tour_variable_name_label: 'Помощ: променлива име етикет.',
  dashboard_tour_variable_type: 'Помощ: променлива тип.',
  dashboard_tour_variable_source: 'Помощ: променлива източник.',
  dashboard_tour_variable_value: 'Помощ: променлива стойност.',
  dashboard_tour_variable_actions_form: 'Помощ: променлива действия форма.',
  dashboard_dialog_currently_open: 'Диалогът е отворен.',
};

export default i18n_bg;
